export const IT = {
  AactivityOnboarding: {
    SUMMARY: {
      ACTIVITY_TEXT: 'Frequenza delle uscite'
    }
  },
  HipayPayments: {
    CARDNUMBER: 'Numero della carta',
    EXPIRYDATE: 'Data di scadenza',
    FULLNAME: 'Nome completo',
    GOCARDLESS_LINK: 'Pagare tramite bonifico bancario',
    YOURNAME: 'il tuo nome'
  },
  Slider: {
    GPS_INTERVAL: 'GPS Intervallo',
    GPS_POSITION_REPORT_ENABLED: 'Señal de la posición del GPS activada',
    TRACKER_INTERVAL_TEXT_WARNING: 'Disabilitando la segnalazione automatica della posizione GPS si allunga la durata della batteria. Puoi richiedere manualmente una nuova posizione, ma le zone sicure e la cronologia non funzionano più.'
  },
  TypeSwitch: {
    ANIMAL_SUBTITLE: 'Seleziona l\'animale per il quale hai acquistato il localizzatore:',
    CAT_TYPE: 'Localizzatore gatto',
    DOG_TYPE: 'Localizzatore cani',
    FAMILY_SUBTITLE: 'Per chi hai comprato questo localizatore?',
    KID_TYPE: 'Un bambino',
    SILVER_TYPE: 'Un cittadino anziano',
    TITLE: 'Per chi è il localizzatore?'
  },
  account: {
    LANGUAGE: {
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Si è verificato un problema',
        UPDATE_SUCCESS: 'Lingua aggiornata correttamente'
      }
    },
    NAV: {
      LANGUAGE: 'Lingua',
      PASSWORD: 'Password',
      PAYMENTS: 'Pagamento e fatturazione',
      USER_PREFERENCES: 'Preferenze',
      USER_PROFILE: 'Profilo utente'
    },
    PASSWORD: {
      HEADLINE: 'Modifica della password',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Si è verificato un problema',
        UPDATE_ERROR_WRONG_PASSWORD: 'La vecchia password inserita non è corretta',
        UPDATE_SUCCESS: 'Password aggiornata correttamente'
      }
    },
    PAYMENTS: {
      HISTORY_HEADLINE: 'Cronologia dei pagamenti',
      MAIN_HEADLINE: 'Fatturazione'
    },
    USER_PREFERENCES: {
      EMAIL_PREFERENCES_HEADLINE: 'Preferenze e-mail',
      EMAIL_PREFERENCES_USER_INFO: 'Le preferenze saranno applicate all\'indirizzo e-mail {{user_email}}',
      MAIN_HEADLINE: 'Preferenze',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Si è verificato un problema durante il salvataggio delle preferenze',
        UPDATE_SUCCESS: 'Le preferenze sono state aggiornate correttamente'
      },
      METRIC_PREFERENCES_DESCRIPTION: 'Scegliere l\'unità di misura della distanza utilizzata per il localizzatore.',
      METRIC_PREFERENCES_HEADLINE: 'Preferenza per il sistema metrico:'
    },
    USER_PROFILE: {
      BASIC_INFO_HEADLINE: 'Dati di base',
      BILLING_HEADLINE: 'Indirizzo di fatturazione',
      MAIN_HEADLINE: 'Profilo utente',
      MARKETING_AGREEMENT_TEXT: 'Accetto di ricevere offerte e promozioni dai partner di Weenect',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Si è verificato un problema',
        UPDATE_SUCCESS: 'Dati aggiornati correttamente'
      },
      METRIC_KM: 'Chilometri',
      METRIC_MILES: 'Miglia',
      PREFERRED_METRIC: 'Unità di misura di distanza:'
    }
  },
  activity: {
    AVERAGE_SPEED: 'Velocità media',
    CONTROLS: {
      PAUSE_PLAYING_TITLE: 'Interrompi la visualizzazione della cronologia',
      RESUME_PLAYING_TITLE: 'Fai ripartire la visualizzazione della cronologia',
      START_PLAYING: 'Lancio',
      START_PLAYING_TITLE: 'Lancia la visualizzazione della cronologia',
      STOP_PLAYING: 'Arresto',
      STOP_PLAYING_TITLE: 'Ferma la visualizzazione della cronologia',
      TOGGLE_HEATMAP: 'Mappa termica',
      TOGGLE_HEATMAP_TITLE: 'Visualizza la mappa termica',
      TOGGLE_PATH: 'Tracciato delle posizioni',
      TOGGLE_PATH_TITLE: 'Visualizza il tracciato delle posizioni'
    },
    DETAIL_TITLE: 'Dettaglio dell\'attività',
    EMPTY_LIST: 'Nessun avviso da visualizzare. Modifica il periodo selezionato o verifica che il localizzatore sia acceso.',
    EVENTS: {
      ALERT: 'Pulsante laterale azionato',
      BATTERY: 'Batteria bassa - del {{battery}}% rimanente',
      CALL_END: 'Chiamata SOS terminata',
      CALL_REQ: 'Chiamata SOS richiesta',
      ENTERS_GEOFENCE: 'Ingresso nella zona di sicurezza',
      EXIT_GEOFENCE: 'Uscita dalla zona di sicurezza',
      FLASH_REQ: 'Flash chiesto',
      FREQ_CHANGE: 'Intervallo di tempo modificato',
      RING: 'Suoneria effettuata',
      RING_REQ: 'Suoneria richiesta',
      SOS: 'Avviso SOS',
      TRACKER_OFF: 'Localizzatore spento',
      TRACKER_ON: 'Localizzatore acceso',
      VIBRATE: 'Vibrazione effettuata',
      VIBRATE_REQ: 'Vibrazione richiesta'
    },
    FEEDBACKTEXT: {
      FIRST: '',
      SECOND: ''
    },
    HISTORY_TITLE: 'Cronologia delle notifiche',
    LAST_TIME_PERIOD: 'Mostra le ultime',
    LOADING: 'Caricamento...',
    MAXIMUM_SPEED: 'Velocità massima',
    OBJECTIVE: {
      CONTENT: 'Impostate un obiettivo di attività intensa da raggiungere ogni giorno.',
      DAILY_REACHED: '{{name}} ha raggiunto il suo obiettivo giornaliero!',
      HELPTEXT: 'Quando si misura l\'obiettivo giornaliero si tiene conto solo dell\'attività intensa. Ad esempio, una corsa o una sessione di gioco.',
      RECOMENDED_VALUE: 'Obiettivo consigliato: 1 ora',
      SUBTEXT: 'Il nostro algoritmo registra ogni movimento del localizzatore e classifica i risultati in base al livello di intensità. In questo modo possiamo determinare se si tratta di attività intensa, veglia o riposo.',
      TITLE: 'Obiettivo giornaliero'
    },
    ONBOARDING: {
      FIRST_SUBTEXT: 'Questo strumento consente di monitorare l\'attività quotidiana del tuo amico a quattro zampe.',
      SECOND_SUBTEXT: 'Quanto tempo ha dormito? Quanti passi ha fatto oggi?',
      START: 'Inizia!',
      THIRD_SUBTEXT: 'Potrete anche impostare un obiettivo in base alla razza del vostro animale, in modo da garantirgli l\'attività quotidiana di cui ha bisogno.',
      TITLE: 'Benvenuti nell\'activity localizzatore Weenect!'
    },
    PROGRESSBAR: {
      TITLE: 'Obiettivo quotidiano'
    },
    SELECT_DAY: 'Scegli un giorno da visualizzare',
    SELECT_TIME: 'Usa cursore per selezionare l’intervallo di tempo da visualizzare',
    SUMMARY: {
      ACTIVITY: 'Intenso',
      AWAKENING: 'Moderato',
      DATEINTERVAL: '',
      DAY_INDEX: 'g',
      DISTRIBUTIONTEXT: 'Rapporto dettagliato',
      HOUR_INDEX: 'h',
      LASTWEEK: '',
      MENU_TITLE: 'Rapporto di attività',
      MIN_INDEX: 'min',
      MODIFY_PERIOD: 'Modifica le date',
      PREVIOUS_DAY: '',
      PREVIOUS_MONTH: '',
      PREVIOUS_WEEK: '',
      REGISTERED_ACTIVITY: 'passi',
      REPORT: 'Visualizza il rapporto \n',
      REST: 'Basso',
      SUBTEXT: 'Ancora {{time}} di attività intensa prima di raggiungere l\'obiettivo di {{name}}.',
      TEXT_OBJECTIVE_COMPLETED: '{{name}} ha raggiunto il suo obiettivo giornaliero!',
      TEXT_OBJECTIVE_COMPLETED_TREAT: 'Congratulazioni, {{name}} ha raggiunto il suo obiettivo! Forse questo merita un trattamento?',
      TEXT_OBJECTIVE_NONE: '{{name}} non ha dati per questo periodo',
      TEXT_OBJECTIVE_NONE_VERIFY_TRACKER: '{{name}} non ha ancora registrato alcun movimento. Controllare che il localizzatore sia acceso e che la batteria sia carica!',
      TITTLE: 'I progressi di {{name}}',
      TODAY: 'Oggi,',
      TOTAL: 'Totale',
      YESTERDAY: 'ieri'
    },
    TIME_ELAPSED: 'Durata',
    TOTAL_DISTANCE: 'Distanza totale'
  },
  activityGeneral: {
    BEHAVIOR: 'Attività',
    STANDARD_MORPHOLOGY: 'Morfologia ',
    STERILIZED: 'Sterilizzato'
  },
  activityOnboarding: {
    COMMON: {
      STEP: 'Fase',
      TRACKER_PROFIL: 'Profilo del localizzatore'
    },
    MONTH: {
      APRIL: 'Aprile',
      AUGUST: 'Agosto',
      DECEMBER: 'Dicembre',
      FEBRUARY: 'Febbraio',
      JANUARY: 'Gennaio',
      JULY: 'Luglio',
      JUNE: 'Giugno',
      MARCH: 'Marzo',
      MAY: 'Maggio',
      NOVEMBER: 'Novembre',
      OCTOBER: 'Ottobre',
      SEPTEMBER: 'Settembre'
    },
    PET_ACTIVITY: {
      FIRST_BUTTON: 'Casalingo (il minimo indispensabile)',
      FIRST_BUTTON_CAT: 'Eccezionalmente (vacanze, imprevisti...)',
      FIRST_BUTTON_DOG: 'Solo per i propri bisogni',
      FOURTH_BUTTON: 'Iperattivo (2 o 3 passeggiate al giorno)',
      FOURTH_BUTTON_CAT: 'Regolarmente, giorno e notte',
      FOURTH_BUTTON_DOG: '2 a 3 passeggiate al giorno',
      SECOND_BUTTON: 'Normale (2 o 3 passeggiate a settimana)',
      SECOND_BUTTON_CAT: 'Di tanto in tanto, su sua richiesta\n',
      SECOND_BUTTON_DOG: '2 o 3 passeggiate a settimana',
      SELECT_ACTIVITY: 'Quanto spesso esce?',
      THIRD_BUTTON: 'Energico (una passeggiata al giorno)',
      THIRD_BUTTON_CAT: 'Regolarmente, durante il giorno\n',
      THIRD_BUTTON_DOG: 'Una passeggiata al giorno',
      TITLE: 'Qual è il suo profilo sportivo?'
    },
    PET_AGE: {
      FIRST_COMMON_TEXT: 'anno/i e ',
      SECOND_COMMON_TEXT: 'mesi',
      TITLE: 'Qual è la sua data di nascita?'
    },
    PET_GENDER: {
      FEMALE: 'Una femmina',
      FIRST_TITLE: 'Il tuo animale è una femmina o un maschio?',
      MALE: 'Un maschio',
      SECOND_TITLE: 'Il tuo animale è sterilizzato?'
    },
    PET_HEALTH: {
      LAST_VACINATION: 'Quando è stata fatta l\'ultima vaccinazione?',
      LAST_VET_VISIT: 'Quando è stata l\'ultima visita dal veterinario?\n',
      TITLE: 'Punto salute'
    },
    PET_IDENTIFICATION: {
      CHIP: 'Microchip',
      NONE: 'Il mio animale non è identificato',
      SELECT_IDENTIFICATION: 'Com\'è identificato?',
      TATTOO: 'Tatuaggio'
    },
    PET_INFO: {
      GET_STARTED: 'Pronti, partenza, via!',
      NEED_TO_KNOW: 'Per noi è importante imparare a conoscere {{name}} .',
      PETS_DETAILS: 'Inserisci le informazioni del tuo animale.',
      PETS_GENDER: {
        MIXED_BREED: 'È un crociato'
      },
      PET_GENDER_COMMON: 'Il tuo animale è…',
      SECOND_PETS_DETAILS: 'Inserisci le informazioni del tuo amico a 4 zampe'
    },
    PET_MORPH: {
      AVERAGE: 'Normale',
      COMMON_TEXT: 'Circa',
      FIRST_TITLE: 'Qual è la sua morfologia?',
      HELP_TEXT: 'Come posso definire la morfologia del mio animale?\n',
      LEAN: 'Magro',
      OBESE: 'Obeso',
      OVERWEIGHT: 'In sovrappeso',
      SECOND_TITLE: 'Qual è il suo peso?',
      WEIGH_TEXT: 'Qual è il peso del vostro animale?\n'
    },
    PET_NAME: {
      COMMON_TEXT: 'Ci piacerebbe saper di più sul tuo animale!\u2028 Potrai modificare queste informazioni in seguito nei parametri. ',
      PLACEHOLDER: 'Nome dell\'animale',
      TITLE: 'Come si chiama?'
    },
    PET_RACE: {
      COMMON_TEXT: 'Non conosco la sua razza',
      PLACEHOLDER: 'Razza del cane',
      SELECT_BREED: 'Seleziona la razza',
      TITLE: 'Qual è la sua razza?'
    },
    PET_TYPE: {
      CAT: 'Un gatto',
      DOG: 'Un cane'
    },
    SUMMARY: {
      BIRTH_DATE: 'Data di nascita',
      BREED: 'Razza',
      CONDITION: 'Condizione',
      DAILY_EXERCISE: 'Movimento quotidiano',
      DELETE: 'Reimpostare il profilo',
      HEALTH: 'Salute',
      IDENTIFICATION: 'Identificazione',
      MODAL: {
        NO: 'No, annulla',
        SUBTEXT: 'Dovrete quindi ricominciare il processo da capo.',
        TITLE: 'Siete sicuri di voler reimpostare i dati del vostro animale domestico?',
        YES: 'Si, sono sicuro'
      },
      MORPHOLOGY: 'Morfologia',
      NAME: 'Nome',
      RECAPTEXT: 'Ecco le informazioni fornite sul tuo compagno.',
      SEX: 'Sesso',
      SPECIES: 'Specie',
      SUBMIT: 'Conferma il profilo',
      UNSPECIFIED: 'vuoto',
      VALIDATION: 'Conferma del profilo',
      VALIDATION_TEXT: 'Conferma le informazioni prima di continuare. ',
      WEIGHT: 'Peso'
    }
  },
  activityTracking: {
    ACTIVITY: 'di attività',
    ACTIVITY_DISTRIBUTION: {
      DATA_COMPARATOR: {
        ACTIVITY_INTENSE: 'Attività intensa',
        ACTIVITY_INTENSE_LEGEND: 'di attività intensa {{day}}',
        ACTIVITY_MODERATE: 'Attività moderata',
        ACTIVITY_MODERATE_LEGEND: 'di attività moderata {{day}}',
        ACTIVITY_WEAK: 'Attività scarsa',
        ACTIVITY_WEAK_LEGEND: 'di attività leggera {{day}}',
        TEXT: 'Ieri {{petName}} ha avuto un\'attività {{activity}} {{comparator}} rispetto a {{day}}.'
      }
    },
    ACTIVITY_REPORT: {
      DATA_COMPARATOR: {
        LEGEND: {
          KM_MONTHLY: 'chilometri medi giornalieri questo mese',
          KM_WEEKLY: 'chilometri medi giornalieri questa settimana',
          KM_YESTERDAY: 'chilometri percorsi nella giornata di ieri',
          STEP_MONTHLY: 'passi medi giornalieri questo mese',
          STEP_WEEKLY: 'passi medi giornalieri questa settimana',
          STEP_YESTERDAY: 'passi fatti nella giornata di ieri'
        },
        TEXT_INF: 'inferiore',
        TEXT_KM_DAILY: 'Il numero di chilometri percorsi ieri da {{petName}} è {{comparator}} rispetto al numero di chilometri percorsi l\'altro ieri.',
        TEXT_KM_MONTHLY: 'Il numero medio di chilometri percorsi questa settimana da {{petName}} è {{comparator}} rispetto alla media di questo mese.',
        TEXT_KM_WEEKLY: 'Il numero di chilometri percorsi ieri da {{petName}} è {{comparator}} rispetto alla media giornaliera di questa settimana.',
        TEXT_SIM: 'simile',
        TEXT_STEP_DAILY: 'Il numero di passi fatti ieri da {{petName}} è {{comparator}} rispetto al numero di passi fatti l\'altro ieri.',
        TEXT_STEP_MONTHLY: 'La media dei passi fatti questa settimana da {{petName}} è {{comparator}} a quella di questo mese.',
        TEXT_STEP_WEEKLY: 'Il numero di passi fatti ieri da {{petName}} è {{comparator}} alla sua media settimanale.',
        TEXT_SUP: 'superiore',
        TITLE_KM_TRAVELED: 'Chilometri percorsi',
        TITLE_STEP: 'Passi effettuati'
      },
      KM_TRAVELED: '{{step}} chilometri percorsi'
    },
    AIMED_GOAL: {
      ALERT: 'Raccomandiamo un obiettivo giornaliero di almeno 3 ore per mantenere il tuo animale in salute.',
      TITLE: 'Imposta un obiettivo di attività da raggiungere ogni giorno.'
    },
    DAILY_CHART: 'Attività di {{petName}}',
    DAILY_GOAL: {
      NOT_RECOMMENDED: 'Obiettivo sconsigliato',
      RECOMMENDED: 'Obiettivo consigliato',
      SECOND_TITLE: 'Obiettivo quotidiano',
      TITLE: 'Obiettivo quotidiano'
    },
    DAILY_STEP: 'Passi giornalieri',
    DAYS: 'Giorno',
    EQUAL: 'della stessa lunghezza',
    ERROR_PAGE: {
      BUTTON_TEXT: 'Chiudi la pagina',
      TEXT: 'Non possiamo caricare la pagina al momento. Si prega di riprovare più tardi.',
      TITLE: 'Ops, abbiamo riscontrato un problema...'
    },
    HEADER: {
      ACTIVITY_DISTRIBUTION: {
        TITLE: 'Distribuzione dell\'attività'
      },
      ACTIVITY_REPORT: {
        TITLE: 'Rapporti dell\'attività'
      },
      GOAL: {
        TITLE: 'Obiettivo quotidiano'
      }
    },
    HOME: {
      ACTIVITY_DISTRIBUTION: {
        INTENSE: 'Intenso',
        MODERATE: 'Moderato',
        WEAK: 'Basso'
      },
      ALERT: 'Sono necessari alcuni giorni di apprendimento per garantire dati affidabili. Durante questo periodo, l\'algoritmo raccoglie e analizza i tuoi dati per capire le abitudini e il comportamento del tuo animale. Col passare del tempo, i risultati diventeranno sempre più precisi e adatti al suo profilo.',
      FIRST_SECTION: {
        TITLE: 'Obiettivo quotidiano'
      },
      INSURANCE: {
        BUTTON: 'Scopri Weenect Assicurazione',
        TEXT: 'È necessaria una visita dal veterinario. Affidati a Weenect per farti rimborsare la tua visita.'
      },
      MODIFY: 'Modifica',
      PROFILE: {
        SUBTITLE: 'Controlla la sua attività quotidiana per tenerlo in forma.'
      },
      SECOND_SECTION: {
        SUBTITLE: 'Oggi.',
        TITLE: 'Distribuzione'
      },
      SEE_MORE: 'Scopri di più',
      THIRD_SECTION: {
        TITLE: 'Punti chiave'
      }
    },
    HOUR: '{{count}} h',
    HOURS: 'Ore',
    INTERVAL: {
      TEXT: 'Sposta i bordi del grafico per cambiare il periodo visualizzato.',
      TITLE: 'Selezione del periodo'
    },
    KEY_POINTS: 'Punti chiave',
    KILOMETERS: 'Chilometri',
    LESS: 'più corta',
    MIN: 'Minuti',
    MINUTE_ACTIVITY_one: '{{count}} minuto di attività',
    MINUTE_ACTIVITY_other: '{{count}} minuti di attività',
    MINUTE_one: '{{count}} minuto',
    MINUTE_other: '{{count}} minuti',
    MIN_one: '{{count}} min',
    MIN_other: '{{count}} min',
    MONTHLY_STEP: 'Passi mensili',
    ONBOARDING: {
      FIRST_STEP: {
        ALERT: ' L\'attività continua a essere registrata anche in modalità aereo.  Viene visualizzata nel riquadro di controllo non appena si lascia la zona wifi.',
        BUTTON: 'Inizia',
        MESSAGE: 'Questo strumento consente di monitorare l\'attività quotidiana del tuo amico a quattro zampe.  Quanto tempo ha dormito? Quanti passi ha fatto oggi? Presto saprai tutto!',
        TITLE: 'Benvenuti nel monitoraggio dell\'attività del vostro animale!'
      },
      SECONDE_STEP: {
        BUTTON: 'Salva',
        PROFILE: {
          SUBTITLE: 'Controlla la sua attività quotidiana per tenerlo in forma.',
          TITLE: 'Attività di {{petName}}'
        },
        TITLE: 'Imposta un obiettivo di attività da raggiungere ogni giorno.'
      }
    },
    PERIOD: {
      DAY: 'Giorno',
      MONTH: 'Mese',
      TITLE: 'Selezione del periodo',
      WEEK: 'Settimana',
      YEAR: 'Anno'
    },
    PLUS: 'più lunga',
    RETURN_HOME: 'Torna alla home',
    STEP: 'Passi',
    STEP_SAVED: '{{step}} passi',
    TEXT: 'Questo grafico ti indica l\'evoluzione dell\'attività del tuo animale. Questa attività viene misurata su un intervallo che parte da 0 e che non ha un limite massimo. Ogni punto di attività rappresenta un\'accelerazione, ovvero uno spostamento del tuo animale.',
    TOTAL: 'Totale',
    WEEKDAYS: {
      FRIDAY: 'Venerdì',
      FRIDAY_COMPARATIVE: 'venerdì',
      MONDAY: 'Lunedì',
      MONDAY_COMPARATIVE: 'lunedì',
      SATURDAY: 'Sabato',
      SATURDAY_COMPARATIVE: 'sabato',
      SUNDAY: 'Domenica',
      SUNDAY_COMPARATIVE: 'domenica',
      THURSDAY: 'Giovedì',
      THURSDAY_COMPARATIVE: 'giovedì',
      TUESDAY: 'Martedì',
      TUESDAY_COMPARATIVE: 'martedì',
      WEDNESDAY: 'Mercoledì',
      WEDNESDAY_COMPARATIVE: 'mercoledì'
    },
    WEEKLY_STEP: 'Passi settimanali',
    YESTERDAY: 'ieri'
  },
  alertCustomer: {
    BODY0: 'Attualmente è in corso una manutenzione presso il nostro fornitore di schede SIM.',
    BODY1: 'Durante questa manutenzione, <1>il tempo di attivazione è esteso a 24 ore</1>.',
    BODY2: 'Siamo ben consapevoli del disagio che ciò rappresenta. Vi preghiamo di scusarci per questo problema indipendente dalla nostra volontà.\n\nPer ulteriori informazioni, potete contattare il nostro team all\'indirizzo mail <1>family@weenect.com</1> o telefonicamente al +33.1.87.66.00.83.',
    FOOTER: 'Il team Weenect'
  },
  animalInfo: {
    ERROR: 'Errore',
    LANDING_PAGE: {
      BUTTON: 'Inizia',
      TEXT: 'Dicci di più sui tuoi amici a quattro zampe. Potrai sempre modificare queste informazioni nelle impostazioni.',
      TITLE: 'Inserisci le informazioni del tuo animale!',
      WARNING: 'Queste informazioni sono necessarie per un monitoraggio dell\'attività il più preciso possibile e per personalizzare la tua esperienza Weenect.'
    },
    NEXT_BUTTON: 'Successivo',
    PROFIL_VALIDATION: {
      ACTIVITY: 'Attività e comportamento',
      BUTTON: 'Convalida del profilo',
      ERROR: 'Error',
      INDENTIFICATION_INFOS: 'Informazioni di identificazione',
      MEDICAL_HISTORY: 'Storia medica',
      PERSONAL_INFOS: 'Informazioni personali',
      PHYSICAL: 'Caratteristiche fisiche',
      SEX: 'Sesso',
      SPECIES: 'Specie',
      TITLE: 'Convalidazione del profilo',
      UNIQUE_IDENTIFICATION: 'Identificazione unica'
    },
    QUESTION: 'Domanda',
    QUESTION_EIGHT: {
      NO: 'No',
      NOT_STERILIZED: 'Non sterilizzato',
      QUESTION: 'Il tuo animale è sterilizzato?',
      STERILIZATION_STATUS: 'Stato di sterilizzazione',
      STERILIZED: 'Sterilizzato',
      YES: 'Sì'
    },
    QUESTION_ELEVEN: {
      EVERYTIME: 'Spesso',
      EXIT_FREQUENCY: 'Frequenza delle uscite',
      MOSTLY: 'Di tanto in tanto',
      OFTEN: 'Regolarmente',
      QUESTION: 'Quanto spesso esce?',
      RARELY: 'Raramente'
    },
    QUESTION_FIVE: {
      QUESTION: 'Quanto pesa il tuo animale?',
      WEIGHT: 'Peso'
    },
    QUESTION_FOUR: {
      FEMALE: 'Femmina',
      MALE: 'Maschio',
      QUESTION: 'Qual è il sesso del tuo animale?'
    },
    QUESTION_NINE: {
      LAST_VISIT: 'ultima visita',
      QUESTION: 'Quando è stata l\'ultima visita dal veterinario?'
    },
    QUESTION_ONE: {
      CAT: 'Un gatto',
      DOG: 'Un cane',
      QUESTION: 'Qual è il profilo del tuo animale?'
    },
    QUESTION_SEVEN: {
      CHIPED: 'Microchip',
      IDENTIFICATION: 'Identificazione',
      NOT_IDENTIFIED: 'Il mio animale non è identificato',
      QUESTION: 'Come lo si può identificare?',
      TATTOED: 'Tatuaggio'
    },
    QUESTION_SIX: {
      QUESTION: 'Qual è la razza del tuo animale?',
      RACE: 'Razza'
    },
    QUESTION_TEN: {
      LAST_VACCIN: 'Ultimo vaccino',
      QUESTION: 'E il suo ultimo vaccino?'
    },
    QUESTION_THREE: {
      BIRTHDATE: 'Data di nascita',
      QUESTION: 'Qual è la sua data di nascita?'
    },
    QUESTION_TWO: {
      NAME: 'Nome',
      QUESTION: 'Come si chiama?'
    },
    santevet: {
      description: 'Proteggi {{animal_name}} con l’assicurazione sanitaria numero 1 per cani e gatti.',
      optin: 'Accetto di essere contattato da Santévet per usufruire dei miei primi 3 mesi gratuiti.',
      title: '3 mesi gratuiti !'
    }
  },
  breed: {
    CAT: {
      ABYSSINIAN: 'Abissino',
      AMERICAN_BOBTAIL: 'Bobtail Americano',
      AMERICAN_CURL: 'American Curl',
      AMERICAN_SHORTHAIR: 'American Shorthair',
      AMERICAN_WIREHAIR: 'American Wirehair',
      BALINESE: 'Balinese',
      BENGAL: 'Bengala',
      BIRMAN: 'Birmano',
      BOMBAY: 'Bombay americano',
      BURMESE: 'Burmese',
      BURMILLA: 'Burmilla',
      CALIFORNIA_SPANGLED_CAT: 'California Spangled',
      CHANTILLYTIFFANY: 'Tiffany',
      CHARTREUX: 'Certosino',
      CORNISH_REX: 'Cornish Rex',
      CYMRIC: 'Cymric',
      DEVON_REX: 'Devon Rex',
      EGYPTIAN_MAU: 'Mau egiziano',
      EUROPEAN: 'Europeo',
      EXOTIC_SHORTHAIR: 'Exotic Shorthair',
      HAVANA: 'Havana Brown',
      JAPANESE_BOBTAIL: 'Bobtail giapponese',
      JAVANESE: 'Giavanese',
      KORAT: 'Korat',
      MAINE_COON: 'Maine Coon',
      MALAYAN: 'Asian',
      MANX: 'Manx',
      MUNCHKIN: 'Munchkin',
      NEBELUNG: 'Nebelung',
      NORWEGIAN: 'Norvegese ',
      NORWEGIAN_FOREST_CAT: 'Norvegese delle foreste',
      OCICAT: 'Ocicat',
      ORIENTAL_LONGHAIR: 'Orientale a pelo lungo',
      ORIENTAL_SHORTHAIR: 'Orientale a pelo corto',
      PERSIAN: 'Persiano',
      RAGDOLL: 'Ragdoll',
      RUSSIAN_BLUE: 'Blu di Russia',
      SAFARI_CAT: 'Safari',
      SCOTTISH_FOLD: 'Scottish Fold',
      SELKIRK: 'Selkirk Rex',
      SIAMESE: 'Siamese',
      SIBERIAN: 'Siberiano',
      SINGAPURA: 'Singapura',
      SNOWSHOE: 'Snowshoe',
      SOMALI: 'Somalo',
      SPHYNX: 'Canadian Sphynx',
      THAI: 'Thai',
      TONKINESE: 'Tonchinese',
      TURKISH_ANGORA: 'Turco d\'Angora',
      TURKISH_VAN: 'Turco Van'
    },
    DOG: {
      AFFENPINSCHER: 'Affenpinscher',
      AFGHAN_HOUND: 'Levriero Afgano',
      AIREDALE_TERRIER: 'Airedale Terrier',
      AKITA: 'Akita',
      AKITA_INU_GREAT_JAPANESE_DOG: 'Grande cane Giapponese (Akita Americano)',
      ALASKAN_MALAMUTE: 'Alaskan Malamute',
      ALPINE_DACHSBRACKE: 'Basset des Alpes',
      AMERICAN_BULLDOG: 'Bulldog Americano',
      AMERICAN_COCKER_SPANIEL: 'Cocker Americano',
      AMERICAN_FOXHOUND: 'American Foxhound ',
      AMERICAN_STAFFORDSHIRE_TERRIER: 'American Staffordshire Terrier',
      AMERICAN_WATER_SPANIEL: 'American Water Spaniel ',
      ANATOLIAN_SHEPHERD_DOG: 'Pastore dell\'Anatolia (Kangal Çoban köpeği)',
      APPENZELLER_SENNENHUND: 'Bovaro dell\'Appenzell ',
      ARDENNES_CATTLE_DOG: 'Bovaro delle Ardenne ',
      ARGENTINE_DOGO: 'Dogo Argentino',
      ARIEGEOIS: 'Ariégeois',
      ARIEGE_POINTER: 'Bracco d\'Ariège',
      ARTOIS_HOUND: 'Chien d\'Artois',
      ATLAS_SHEPHERD_DOG_AIDI: 'Cane dell\'Atlas (Aïdi - Atlas Mountain Dog)',
      AUSTRALIAN_CATTLE_DOG: 'Australian Cattle Dog',
      AUSTRALIAN_KELPIE: 'Pastore Australiano Kelpie',
      AUSTRALIAN_SHEPHERD: 'Pastore Australiano',
      AUSTRALIAN_TERRIER: 'Australian Terrier',
      AUSTRIAN_BLACK_AND_TAN_HOUND: 'Segugio Austriaco nero focato',
      AUSTRIAN_SHORTHAIRED_PINSCHER: 'Pinscher Austriaco a pelo corto',
      AZAWAKH: 'Azawakh',
      BALKAN_HOUND: 'Segugio Serbo',
      BARBET: 'Barbet',
      BASENJI: 'Basenji',
      BASSET_ARTESIEN_NORMAND: 'Basset Artésien Normand',
      BASSET_BLEU_DE_GASCOGNE: 'Basset Bleu de Gascogne',
      BASSET_FAUVE_DE_BRETAGNE: 'Basset Fauve de Bretagne',
      BASSET_HOUND: 'Basset Hound',
      BAVARIAN_MOUNTAIN_SCENTHOUND: 'Segugio Bavarese da montagna (Bayerischer Gebirgsschweisshund)',
      BEAGLE: 'Beagle',
      BEARDED_COLLIE: 'Bearded Collie',
      BEAUCERON: 'Pastore di Beauce (Beauceron)',
      BEDLINGTON_TERRIER: 'Bedlington Terrier',
      BELGIAN_GRIFFON: 'Griffone Belga',
      BELGIAN_SHEPHERD_DOG_GROENENDAEL: 'Pastore Belga Groenendael',
      BELGIAN_SHEPHERD_DOG_LAEKENOIS: 'Pastore Belga Laekenois',
      BELGIAN_SHEPHERD_DOG_MALINOIS: 'Pastore Belga Malinois',
      BELGIAN_SHEPHERD_DOG_TERVUREN: 'Pastore Belga Tervueren',
      BERGAMASCO_SHEPHERD: 'Pastore Bergamasco',
      BERNER_NIEDERLAUFHUND: 'Piccolo Segugio del Bernese',
      BERNESE_HOUND: 'Segugio del Bernese',
      BERNESE_MOUNTAIN_DOG: 'Bovaro del Bernese',
      BICHON_FRISE: 'Bichon à poil Frisé',
      BILLY_DOG: 'Billy',
      BLACK_AND_TAN_COONHOUND: 'Black and tan Coonhound ',
      BLOODHOUND_SAINTHUBERT_DOG: 'Cane di sant\'Uberto',
      BLUE_PICARDY_SPANIEL: 'Epagneul Bleu de Picardie',
      BOHEMIAN_WIREHAIRED_POINTING_GRIFFON: 'Český fousek',
      BOLOGNESE_DOG: 'Bolognese',
      BORDEAUX_MASTIFF_FRENCH_MASTIFF: 'Dogue de Bordeaux',
      BORDER_COLLIE: 'Border Collie',
      BORDER_TERRIER: 'Border Terrier',
      BORZOI: 'Barzoï (Levriero russo)',
      BOSNIAN_COARSEHAIRED_HOUND: 'Segugio della Bosnia a pelo duro ',
      BOSTON_TERRIER: 'Boston Terrier',
      BOURBONNAIS_POINTER: 'Bracco del Bourbonnais',
      BOUVIER_DES_FLANDRES: 'Bovaro delle Fiandre',
      BOXER_DOG: 'Boxer',
      BRAQUE_D_AUVERGNE: 'Bracco d\'Auvergne ',
      BRAZILIAN_TERRIER: 'Terrier Brasileiro (Fox Paulistinha)',
      BRIARD: 'Pastore di Brie',
      BRIQUET_GRIFFON_VENDEEN: 'Briquet Griffon Vendéen',
      BRITTANY_SPANIEL: 'Epagneul Breton',
      BROHOLMER: 'Broholmer',
      BRUNO_JURA_HOUND: 'Piccolo Segugio del Giura',
      BRUNO_JURA_HOUND_BRUNO_TYPE: 'Segugio del Giura tipo Bruno',
      BRUNO_JURA_HOUND_ST_HUBERT_TYPE: 'Segugio del Giura tipo Sant\'umberto',
      BRUSSELS_GRIFFON: 'Griffone di Bruxelles',
      BULLMASTIFF: 'Bullmastiff',
      BULL_TERRIER_ENGLISH_BULL_TERRIER: 'Bull Terrier',
      BURGOS_POINTER: 'Bracco di Burgos',
      CAIRN_TERRIER: 'Cairn Terrier',
      CANAAN_DOG: 'Canaan Dog',
      CANARY_ISLAND_PODENCO: 'Podenco Canario',
      CANE_CORSO: 'Cane Corso Italiano',
      CAO_DE_CASTRO_LABOREIRO: 'Cão de Castro Laboreiro',
      CAO_FILA_DE_SAO_MIGUEL: 'Cão fila de São Miguel (Fila Portoghese)',
      CATAHOULA_LEOPARD_DOG: 'Catahoula Leopard Dog',
      CATALAN_SHEEPDOG: 'Pastore Catalano',
      CAUCASIAN_SHEPHERD_DOG: 'Pastore del Caucaso',
      CAVALIER_KING_CHARLES_SPANIEL: 'Cavalier King Charles Spaniel',
      CA_DE_BOU_PERRO_DE_PRESA: 'Perro Dogo Mallorquín (Mastino di Maiorca - Ca de Bou)',
      CENTRAL_ASIAN_SHEPHERD_DOG: 'Pastore dell\'Asia centrale',
      CESKY_TERRIER: 'Terrier Boemo (Cesky Terrier)',
      CHESAPEAKE_BAY_RETRIEVER: 'Chesapeake Bay Retriever',
      CHIHUAHUA: 'Chihuahua',
      CHINESE_CRESTED_DOG: 'Crestato cinese (Chinese Crested)',
      CHOW_CHOW: 'Chow Chow',
      CIRNECO_DELL_ETNA: 'Cirneco dell\'Etna',
      CLUMBER_SPANIEL: 'Clumber Spaniel ',
      CONTINENTAL_TOY_SPANIEL: 'Papillon (Épagneul nano continentale)',
      CORSICAN_DOG: 'Cursinu',
      COTON_DE_TULEAR: 'Coton de Tuléar',
      CROATIAN_SHEEPDOG: 'Pastore Croato',
      CURLYCOATED_RETRIEVER: 'Curly Coated Retriever',
      CZECHOSLOVAKIAN_WOLFDOG: 'Cane lupo Cecoslovacco',
      DACHSHUND_LONGHAIRED: 'Bassotto Tedesco a pelo lungo',
      DACHSHUND_LONGHAIRED_RABBIT: 'Bassotto da caccia al coniglio (pelo lungo)',
      DACHSHUND_SMOOTHHAIRED: 'Bassotto Tedesco a pelo raso',
      DACHSHUND_SMOOTHHAIRED_RABBIT: 'Bassotto da caccia al coniglio (pelo raso)',
      DACHSHUND_WIREHAIRED: 'Bassotto Tedesco a pelo duro',
      DACHSHUND_WIREHAIRED_RABBIT: 'Bassotto da caccia al coniglio (pelo duro)',
      DALMATIAN: 'Dalmata',
      DANDIE_DINMONT_TERRIER: 'Dandie Dinmont Terrier',
      DOBERMAN_PINSCHER: 'Dobermann',
      DOGO_CANARIO: 'Cane da presa Canario (Dogo Canario)',
      DOGUE_DE_BORDEAUX: 'Leone d\'Occitania',
      DRENTSE_PARTRIDGE_DOG: 'Drentse Patrijshond (Dutch Partridge Dog)',
      DREVER: 'Drever',
      DUNKER: 'Dunker',
      DUPUY_POINTER: 'Bracco Dupuy (Dupuy Pointer)',
      DUTCH_SHEPHERD_LONGHAIRED_VARIETY: 'Pastore Olandese a pelo lungo',
      DUTCH_SHEPHERD_ROUGHHAIRED_VARIETY: 'Pastore Olandese a pelo ruvido',
      DUTCH_SHEPHERD_SHORTHAIRED_VARIETY: 'Pastore Olandese a pelo corto',
      DUTCH_SMOUSHOND: 'Piccolo Kooikerhondje',
      EAST_SIBERIAN_LAIKA: 'Laika della Siberia Orientale',
      ENGLISH_BULLDOG: 'Bulldog Inglese',
      ENGLISH_COCKER_SPANIEL: 'Cocker Spaniel Inglese',
      ENGLISH_POINTER: 'Pointer Inglese',
      ENGLISH_SETTER: 'Setter Inglese',
      ENGLISH_SPRINGER_SPANIEL: 'Springer Spaniel Inglese',
      ENGLISH_TOY_TERRIER: 'Toy Terrier nero e fulvo',
      ENTLEBUCHER_MOUNTAIN_DOG: 'Bovaro dell\'Entlebuch',
      EURASIER: 'Eurasier',
      FAWN_BRITTANY_BASSET: 'Griffon Fauve de Bretagne',
      FIELD_SPANIEL: 'Field Spaniel',
      FILA_BRASILEIRO: 'Fila Brasileiro',
      FINNISH_HOUND: 'Segugio Finlandese',
      FINNISH_LAPPHUND: 'Lapinkoira (Suomenlapinkoira)',
      FINNISH_SPITZ: 'Spitz Finnico',
      FLATCOATED_RETRIEVER: 'Flat-Coated Retriever',
      FOXHOUND_ENGLISH_FOXHOUND: 'English Foxhound',
      FRENCH_BULLDOG: 'Bulldog Francese',
      FRENCH_SPANIEL: 'Spaniel Francese',
      FRENCH_WHITE_AND_BLACK_HOUND: 'Segugio Francese Bianco e Nero',
      FRENCH_WHITE_AND_ORANGE_HOUND: 'Français Blanc et Orange ',
      FRISIAN_WATER_DOG: 'Spaniel Olandese (Wetterhoun)',
      GASCONY_POINTER: 'Bracco Francese tipo Gascogne',
      GERMAN_LONGHAIRED_POINTER: 'Bracco Tedesco a pelo lungo',
      GERMAN_PINSCHER: 'Pinscher Medio',
      GERMAN_SHEPHERD: 'Pastore Tedesco',
      GERMAN_SHORTHAIRED_POINTER: 'Bracco Tedesco a pelo corto',
      GERMAN_SPITZ: 'Spitz Tedesco (Grande)',
      GERMAN_WIREHAIRED_POINTER: 'Bracco Tedesco a pelo duro',
      GIANT_SCHNAUZER: 'Schnauzer gigante',
      GLEN_OF_IMAAL_TERRIER: 'Irish Glen of Imaal Terrier',
      GOLDEN_RETRIEVER: 'Golden Retriever',
      GORDON_SETTER: 'Setter Scozzese (Setter Gordon)',
      GOTH_SHEPHERD_DOG: 'Västgötaspets ',
      GRAND_ANGLOFRANCAIS_BLANC_ET_NOIR: 'Grande Anglo-Francese Bianco e Nero',
      GRAND_ANGLOFRANCAIS_BLANC_ET_ORANGE: 'Grande Anglo-Francese Bianco e Arancio',
      GRAND_ANGLOFRANCAIS_TRICOLORE: 'Grande Anglo-Francese Tricolore',
      GRAND_BASSET_GRIFFON_VENDEEN: 'Grand Basset Griffon Vendéen',
      GRAND_BLEU_DE_GASCOGNE: 'Grand Bleu de Gascogne',
      GRAND_GASCONSAINTONGEOIS_HOUND: 'Gascon Saintongeois',
      GRAND_GRIFFON_VENDEEN: 'Grand Griffon Vendéen',
      GRAND_SPANISH_HOUND: 'Sabueso Espagnol (grande)',
      GREATER_SWISS_MOUNTAIN_DOG: 'Grande Bovaro Svizzero',
      GREAT_DANE: 'Alano Tedesco',
      GREAT_PYRENEES: 'Cane da montagna dei Pirenei (Patou)',
      GREENLAND_DOG: 'Groenlandese',
      GREYHOUND: 'Greyhound',
      HALDEN_HOUND: 'Segugio di Halden',
      HAMILTONSTOVARE: 'Hamiltonstövare',
      HANOVERIAN_SCENTHOUND: 'Segugio di Hannover',
      HANOVER_HOUND: 'Bracco Tedesco a pelo corto',
      HARRIER: 'Beagle-harrier',
      HAVANESE_DOG: 'Bichon Havanais',
      HELLENIC_HOUND: 'Segugio Ellenico',
      HOKKAIDO: 'Hokkaido (Ainu-ken)',
      HOVAWART: 'Hovawart',
      HUNGARIAN_GREYHOUND: 'Levriero Ungherese (Magyar agár)',
      HUNGARIAN_KUVASZ: 'Kuvasz (Pastore Ungherese)',
      HYGEN_HOUND: 'Hygen Hound ',
      IBIZAN_HOUND_SHORT_HAIRED: 'Podenco Ibicenco a pelo corto',
      IBIZAN_HOUND_WIRE_HAIRED: 'Podenco Ibicenco a pelo duro',
      ICELANDIC_SHEEPDOG: 'Pastore Isclandese (Icelandic sheepdog)',
      IRISH_RED_AND_WHITE_SETTER: 'Setter Irlandese rosso',
      IRISH_SETTER: 'Setter Irlandese rosso e bianco',
      IRISH_TERRIER: 'Irish Terrier',
      IRISH_WATER_SPANIEL: 'Irish Water Spaniel',
      IRISH_WOLFHOUND: 'Levriero Irlandese',
      ISTRIAN_COARSEHAIRED_HOUND: 'Segugio dell\'Istria a pelo duro',
      ISTRIAN_SHORTHAIRED_HOUND: 'Segugio dell\'Istria a pelo raso',
      ITALIAN_GREYHOUND: 'Piccolo Levriero Italiano',
      ITALIAN_POINTING_DOG: 'Bracco Italiano',
      ITALIAN_SHORTHAIRED_HOUND: 'Segugio Italiano a pelo raso',
      ITALIAN_SPITZ: 'Volpino Italiano',
      ITALIAN_WIREHAIRED_HOUND: 'Segugio Italiano a pelo forte',
      JACK_RUSSELL_TERRIER: 'Jack Russell Terrier',
      JAGDTERRIER: 'Jagd Terrier',
      JAPANESE_SPANIEL_CHIN: 'Chin',
      JAPANESE_SPITZ: 'Spitz Giapponese',
      JAPANESE_TERRIER: 'Terrier Giapponese',
      KAI_KEN: 'Kai Ken',
      KARELIAN_BEAR_DOG: 'Cane da Orso della Carelia',
      KARST_SHEPHERD: 'Pastore di Karst',
      KERRY_BLUE_TERRIER: 'Kerry Blue Terrier',
      KISHU_KEN: 'Kishu',
      KOMONDOR: 'Komondor',
      KOREAN_JINDO_DOG: 'Jindo Coreano',
      KROMFOHRLANDER: 'Kromfohrländer',
      KYILEO: 'Leone di Kyi (Kyi Leo dog)',
      LABRADOR: 'Labrador',
      LAKELAND_TERRIER: 'Lakeland Terrier',
      LANDSEER: 'Landseer',
      LAPPONIAN_HERDER: 'Lapinporokoira (Lappone Finlandese)',
      LARGE_MUNSTERLANDER: 'Grande Münsterländer',
      LEONBERGER: 'Leonberger (Leonberg)',
      LHASA_APSO: 'Lhassa Apso',
      LOWCHEN_LITTLE_LION_DOG: 'Piccolo Cane Leone',
      LUCERNE_HOUND: 'Segugio di Lucerna ',
      LUZERNER_LAUFHUND: 'Piccolo Segugio di Lucerna ',
      MAJORCA_SHEPHERD_DOG: 'Pastore Mallorquín',
      MALTESE_DOG: 'Maltese',
      MANCHESTER_TERRIER: 'Manchester Terrier ',
      MAREMMA_SHEEPDOG: 'Pastore Maremmano Abruzzese',
      MASTIFF_FRENCH_MASTIFF: 'Mastiff ',
      MEDIUM_POODLE: 'Barbone (Medio)',
      MEXICAN_HAIRLESS_DOG: 'Cane Nudo Messicano (Xoloitzcuintle)',
      MINIATURE_BULL_TERRIER: 'Bull Terrier Miniatura',
      MINIATURE_DACHSHUND_LONGHAIRED: 'Bassotto nano a pelo lungo',
      MINIATURE_DACHSHUND_SMOOTHHAIRED: 'Bassotto nano a pelo raso',
      MINIATURE_DACHSHUND_WIREHAIRED: 'Bassotto nano a pelo duro',
      MINIATURE_PINSCHER: 'Pinscher Nano',
      MINIATURE_POODLE: 'Barbone (Nano)',
      MINIATURE_SCHNAUZER: 'Schnauzer nano',
      MIXED_BREED_CROSSBREED: 'Meticcio ',
      MUDI: 'Mudi (Pastore Ungherese)',
      NEAPOLITAN_MASTIFF: 'Mastino Napoletano',
      NEWFOUNDLAND: 'Terranova',
      NORFOLK_TERRIER: 'Norfolk Terrier',
      NORRBOTTENSPETS: 'Norrbotten Spitz',
      NORWEGIAN_BUHUND: 'Norsk Buhund ',
      NORWEGIAN_ELKHOUND_BLACK: 'Norsk Elghund nero',
      NORWEGIAN_ELKHOUND_GRAY: 'Norsk Elghund grigio',
      NORWEGIAN_LUNDEHUND: 'Norsk Lundehund',
      NORWICH_TERRIER: 'Norwich Terrier',
      NOVA_SCOTIA_DUCK_TOLLING_RETRIEVER: 'Nova Scotia Duck Tolling Retriever (Toller)',
      OLD_DANISH_POINTER: 'Gammel Dansk Hønsehund',
      OLD_ENGLISH_SHEEPDOG: 'Bobtail',
      OTTERHOUND: 'Otterhound',
      PARSON_RUSSELL_TERRIER: 'Parson Russell Terrier',
      PEKINGESE: 'Pechinese',
      PERUVIAN_HAIRLESS_DOG_LARGE: 'Cane Nudo Peruviano (grande)',
      PERUVIAN_HAIRLESS_DOG_MEDIUM: 'Cane Nudo Peruviano (medio)',
      PERUVIAN_HAIRLESS_DOG_SMALL: 'Cane Nudo Peruviano (piccolo)',
      PETIT_BASSET_GRIFFON_VENDEEN: 'Anglo Français de Petite Vénerie',
      PETIT_BRABANCON: 'Piccolo Brabantino',
      PETIT_GASCON_SAINTONGEOIS: 'Piccolo Gascon Saintongeois',
      PHARAOH_HOUND: 'Cane dei Faraoni (Pharaon hound)',
      PICARDY_SHEPHERD: 'Pastore di Piccardia',
      PICARDY_SPANIEL: 'Épagneul Picard',
      POITEVIN: 'Poitevin',
      POLISH_HOUND: 'Segugio Polacco',
      POLISH_LOWLAND_SHEEPDOG: 'Pastore di Vallée',
      PONTAUDEMER_SPANIEL: 'Epagneul de Pont-Audemer ',
      PORCELAINE: 'Porcelaine',
      PORTUGUESE_PODENGO_GRANDE: 'Podengo Portoghese Grande',
      PORTUGUESE_PODENGO_MEDIO: 'Podengo Portoghese Medio',
      PORTUGUESE_PODENGO_PEQUENO: 'Podengo Portoghese Piccolo',
      PORTUGUESE_POINTER: 'Bracco Portoghese',
      PORTUGUESE_SHEEPDOG: 'Pastore Portoghese (Cão da Serra de Aires)',
      PORTUGUESE_SHEEPDOG_LONGHAIRED: 'Cane della Serra da Estrela a pelo ondulato',
      PORTUGUESE_SHEEPDOG_SHORTHAIRED: 'Cane della Serra da Estrela a pelo corto',
      PORTUGUESE_WATER_DOG: 'Cão de água Português',
      POSAVAC_HOUND: 'Segugio Posavatz',
      PRAGUE_RATTER: 'Prague ratter (Pražský krysařík)',
      PUDEL_POINTER: 'Pudelpointer',
      PUG: 'Carlino',
      PULI_HUNGARIAN_SHEPHERD: 'Puli (Pastore Ungherese)',
      PUMI_HUNGARIAN_SHEPHERD: 'Pumi (Pastore Ungherese)',
      PYRENEAN_MOUNTAIN_DOG: 'Mastino dei Pirenei',
      PYRENEAN_POINTER: 'Bracco Francese tipo Pirenei',
      PYRENEAN_SHEEPDOG_LONGFACED_VARIETY: 'Pastore dei Pirenei a pelo lungo ',
      PYRENEAN_SHEEPDOG_SMOOTHFACED_VARIETY: 'Pastore dei Pirenei a faccia rasa',
      RAFEIRO_DE_ALENTEJO: 'Rafeiro do Alentejo',
      REDBONE_COONHOUND: 'Redbone Coonhound',
      REDTICK_COONHOUND: 'American English Coonhound',
      RHODESIAN_RIDGEBACK: 'Rhodesian Ridgeback',
      ROMAGNA_WATER_DOG: 'Lagotto Romagnolo',
      ROTTWEILER: 'Rottweiler',
      ROUGH_COLLIE: 'Pastore Scozzese a pelo lungo',
      RUSSIAN_BLACK_TERRIER: 'Terrier Nero Russo',
      RUSSOEUROPEAN_LAIKA: 'Laika Russo-Europeo',
      SAARLOOSWOLFHOND: 'Cane lupo di Saarloos',
      SAINTUSUGE_SPANIEL: 'Saint-Usuge Spaniel',
      SAINT_BERNARD: 'San Bernardo',
      SALUKI: 'Saluki (Levriero Persiano)',
      SAMOYED: 'Samoiedo',
      SANSHU: 'Sanshu Ken',
      SCHAPENDOES: 'Schapendoes',
      SCHILLERSTOVARE: 'Schillerstovare (Segugio di Schiller)',
      SCHIPPERKE: 'Schipperke',
      SCHWEIZER_LAUFHUND: 'Segugio Svizzero (varietà Schwyz) ',
      SCOTTISH_DEERHOUND: 'Levriero Scozzese (Deerhound)',
      SCOTTISH_TERRIER: 'Scottish Terrier',
      SEALYHAM_TERRIER: 'Sealyham Terrier',
      SHAR_PEI: 'Shar Pei',
      SHETLAND_SHEEPDOG: 'Pastore Scozzese Shetland ',
      SHIBA_INU: 'Shiba ',
      SHIH_TZU: 'Shih Tzu',
      SHIKOKU: 'Sikoku (Kochi-ken - Mikawa Inu)',
      SHORTHAIRED_HUNGARIAN_POINTER: 'Bracco Ungherese a pelo corto',
      SIBERIAN_HUSKY: 'Siberian Husky',
      SILKY_TERRIER: 'Australian Silky Terrier',
      SKYE_TERRIER: 'Skye Terrier',
      SLOUGHI: 'Levriero Arabo',
      SLOVAKIAN_WIREHAIRED_POINTER: 'Bracco Slovacco a pelo duro',
      SLOVAK_CUVAC: 'Cuvac Slovacco',
      SLOVAK_HOUND: 'Segugio Slovacco (Slovenský kopov )',
      SMALAND_HOUND: 'Smalandsstovare',
      SMALL_MUNSTERLANDER: 'Piccolo Münsterländer',
      SMALL_SPANISH_HOUND: 'Sabueso Espagnol (piccolo)',
      SMOOTH_COLLIE: 'Smooth Collie',
      SMOOTH_FOX_TERRIER_ENGLISH_FOX_TERRIER: 'Fox Terrier a pelo liscio (Smooth Fox Terrier)',
      SOFTCOATED_WHEATEN_TERRIER: 'Irish Soft Coated Wheaten Terrier ',
      SOUTH_RUSSIAN_OVCHARKA: 'Pastore della Russia Meridionale',
      SPANISH_GREYHOUND_GALGO_ESPANOL: 'Galgo Español',
      SPANISH_MASTIFF: 'Mastino Spagnolo',
      SPANISH_WATER_DOG: 'Cane d\'acqua Spagnolo',
      SPINONE_ITALIANO: 'Spinone Italiano',
      STABYHOUN: 'Stabyhoun (Stabyhound)',
      STAFFORDSHIRE_BULL_TERRIER: 'Staffordshire Bull Terrier',
      STANDARD_POODLE: 'Barbone (Grande mole)',
      STANDARD_SCHNAUZER: 'Schnauzer medio',
      STICHELHAAR: 'Cane da ferma Tedesco a pelo ruvido (Stichelhaar)',
      STYRIAN_COARSEHAIRED_HOUND: 'Segugio della Stiria a pelo ruvido',
      ST_GERMAIN_POINTING_DOG: 'Bracco Saint Germain',
      SUSSEX_SPANIEL: 'Sussex Spaniel',
      SWEDISH_ELKHOUND: 'Jämthund',
      SWEDISH_LAPPHUND: 'Lapphund svedese (Swedish Lapphund)',
      TATRA_MOUNTAIN_SHEEPDOG: 'Pastore di Tatra',
      TECKEL_DE_CHASSE_AU_LAPIN_POIL_DUR: 'Segugio della Transilvania',
      TIBETAN_MASTIFF: 'Mastino Tibetano (Do-khyi)',
      TIBETAN_SPANIEL: 'Tibetan Spaniel',
      TIBETAN_TERRIER: 'Tibetan Terrier',
      TOSA: 'Tosa',
      TOY_POODLE: 'Barbone (Toy)',
      TRICOLOUR_HOUND: 'Français Tricolore',
      TYROLEAN_HOUND: 'Segugio Tirolese',
      WACHTELHUND: 'Spaniel Tedesco (Deutscher Wachtelhund)',
      WEIMARANER_LONGHAIRED: 'Bracco di Weimar a pelo lungo',
      WEIMARANER_SHORTHAIRED: 'Bracco di Weimar a pelo corto',
      WELSH_CORGI_CARDIGAN: 'Welsh Corgi Cardigan',
      WELSH_CORGI_PEMBROKE: 'Welsh Corgi Pembroke',
      WELSH_SPRINGER_SPANIEL: 'Welsh Springer Spaniel',
      WELSH_TERRIER: 'Welsh Terrier',
      WESTPHALIAN_DACHSBRACKE: 'Segugio della Vestfalia',
      WEST_HIGHLAND_WHITE_TERRIER: 'West Highland White Terrier ',
      WEST_SIBERIAN_LAIKA: 'Laika della Siberia Cccidentale',
      WHIPPET: 'Whippet',
      WHITE_SWISS_SHEPHERD_DOG: 'Pastore Svizzero',
      WIREHAIRED_HUNGARIAN_POINTER: 'Bracco Ungherese a pelo duro',
      WIREHAIRED_POINTING_GRIFFON: 'Griffone a pelo morbido',
      WIRE_FOX_TERRIER: 'Fox Terrier a pelo ruvido',
      YORKSHIRE_TERRIER: 'Yorkshire Terrier',
      YUGOSLAVIAN_MOUNTAIN_HOUND: 'Segugio di Montagna del Montenegro',
      YUGOSLAVIAN_SHEPHERD_DOG: 'Pastore di Ciarplanina ',
      YUGOSLAVIAN_TRICOLOUR_HOUND: 'Segugio Tricolore Jugoslavo'
    }
  },
  changePaymentMean: {
    ADD_BANK_ACCOUNT: 'Aggiungere un conto da addebitare',
    ADD_BANK_CARD: 'Passare al pagamento con carta di credito',
    BANK_ACCOUNT_ERROR: 'Si è verificato un errore durante il caricamento dei dati bancari. Ti preghiamo di contattare il servizio clienti.',
    BANK_ACCOUNT_EXPLANATION: 'Ti informiamo che nessuno dei tuoi dati bancari viene salvato sui nostri server.',
    BANK_ACCOUNT_SUCCESS: 'Dati bancari aggiornati',
    BANK_CARD_ERRORED: 'Impossibile modificare il metodo di pagamento. Ti preghiamo di contattare il <1>servizio clienti</1>.',
    BANK_CARD_UPDATED: 'Carta bancaria aggiornata',
    CAPTATION: 'Per aggiornare i dettagli bancari, autorizzeremo un addebito sulla tua carta per un importo di {{ amount }}.',
    CAPTATION_EXPLANATION1: 'L\'importo non sarà di fatto addebitato perché la transazione viene annullata immediatamente.',
    CAPTATION_EXPLANATION2: 'Questa procedura è necessaria per conformità agli standard dei pagamenti via internet e per garantire la sicurezza dei dati bancari dei clienti. Nessuno di questi dati passa attraverso i nostri server.',
    CAPTATION_EXPLANATION3: 'IMPORTANTE: sul modulo di addebito troverai "Hareau" come beneficiario e non "Weenect". Non preoccuparti, è il nome della nostra azienda. "Weenect" è la denominazione commerciale.',
    CAPTATION_EXPLANATION4: 'Modifica il conto bancario da prelevare mantenendo lo stesso abbonamento.',
    CARD_AUTHORIZED: 'I metodi di pagamento autorizzati sono:',
    CHANGE_PAYMENT_MEAN: 'Aggiorna la tua carta bancaria',
    CURRENT_CHOICE_CB: 'Hai scelto di pagare con carta di credito.',
    CURRENT_CHOICE_IBAN: 'Hai scelto di pagare tramite IBAN',
    CURRENT_MEAN: 'Metodo di pagamento attuale',
    CURRENT_MEAN_PHRASE: 'Hai scelto di pagare con carta di credito',
    CURRENT_MEAN_PHRASE_GOCARDLESS: 'Hai scelto di pagare tramite addebito diretto ',
    DEFAULT_MEAN: 'Metodo di pagamento predefinito:',
    GO_TO_SEPA: 'Passare all\'addebito diretto',
    MODIFY: 'Modifica il metodo di pagamento',
    TITLE: 'Metodo di pagamento',
    UPDATE_BANK_ACCOUNT: 'Aggiornare il mio IBAN',
    UPDATE_BANK_CARD: 'Aggiorna la tua carta bancaria',
    USED_PAYMENT_EXPLANATION: 'Questo metodo di pagamento viene utilizzato per pagare l\'abbonamento e le opzioni.'
  },
  commonActions: {
    ACTIVATE: 'Attiva',
    BACK: 'Indietro',
    CANCEL: 'Annulla',
    CAN_BE_CANCELED: 'E\' possibile disdire in qualsiasi momento.',
    CHANGE: 'Salva',
    CONFIGURE: 'Configura',
    DEACTIVATE: '',
    GO_MAP: 'Vai alla carta',
    MESSAGES: {
      UPDATE_ERROR_UNKNOWN: 'Si è verificato un problema'
    },
    NEXT: 'Seguente',
    NO: 'No ',
    OK: 'Ok',
    REGISTER: 'Attiva',
    SAVE: 'Salva',
    SELECT_ALL: 'Selezionare tutti',
    SEND: 'Invia',
    SUBSCRIBE: 'Attivazione',
    THEN: 'poi',
    UNSELECT_ALL: 'Deselezionare tutti',
    UPDATE: 'Salva',
    VALIDATE: 'Conferma',
    YES: 'Si'
  },
  creditCardAlert: {
    AUTO_RENEWAL_ADVICE: 'Se vuoi continuare a utilizzare il tuo localizzatore, ti preghiamo di inserire un nuovo metodo di pagamento.',
    AUTO_RENEWAL_NOTICE: '<1>Attenzione!</1> Il tuo abbonamento sta per scadere e la tua carta di credito è scaduta.'
  },
  emailPreferences: {
    EMAIL_LISTS: {
      COMPANY_NEWS: 'Ultime notizie dell’azienda',
      NEW_FEATURES: 'Nuove funzionalità',
      OFFERS: 'Offerte promozionali',
      SERVICE_STATUS: 'Guasti dei servizi e aggiornamenti',
      SURVEYS_AND_TESTS: 'Indagini e Beta test',
      TUTORIALS: 'Tutorial'
    },
    EMAIL_LISTS_HEADER: 'Elenco e-mail',
    EMAIL_LISTS_INFO: {
      SERVICE_STATUS: 'Necessario per il corretto funzionamento del servizio.'
    },
    LANGUAGE_PREFERENCES_DESCRIPTION: 'Scegliete la lingua in cui desiderate ricevere le e-mail :',
    PREFERENCES_DECRIPTION: 'Scegliere il tipo di e-mail che si desidera ricevere. Vi invieremo solo quelle che corrispondono alle vostre scelte. '
  },
  error: {
    TITLE: 'Ops si è verificato un problema '
  },
  errors: {
    DEFAULT: 'Campo non valido',
    FIELD_REQUIRED: 'Questo campo è obbligatorio',
    GENERAL: 'Si è verificato un errore, ti preghiamo di riprovare',
    IMEI: 'Inserisci un numero IMEI valido',
    MAIL_FORMAT: 'Questo formato e-mail non è valido',
    MAX_LENGTH: 'Il campo può contenere al massimo 15 caratteri',
    PASSWORD_FORMAT: 'La password deve almeno contenere un numero, una lettera maiuscola, e una minuscola.',
    PHONE_FORMAT: 'Il numero di telefono deve includere il prefisso internazionale',
    PROMO_CODE: 'Codice promozionale non valido'
  },
  forgotPassword: {
    FORGOT_PASSWORD_BUTTON: 'Ricevere un link password dimenticata',
    FORGOT_PASSWORD_CANCEL: 'Ritorna all\'accesso',
    FORGOT_PASSWORD_ERRORS: {
      UNKNOWN: 'Si è verificato un errore. Contattaci tramite l\'assistenza clienti.'
    },
    FORGOT_PASSWORD_EXPIRED: 'Il link per il reset della password è scaduto.',
    FORGOT_PASSWORD_RETRY: 'Chiedere un nuovo link password dimenticata',
    FORGOT_PASSWORD_SUCCESS: 'Se esiste un account associato all\'indirizzo {{mail}}, riceverai un\'e-mail con un link per reimpostare la password.'
  },
  forms: {
    CITY: {
      LABEL: 'Città',
      PLACEHOLDER: 'La tua città'
    },
    CONFIRM_PASSWORD: {
      LABEL: 'Hai dimenticato la password?',
      PLACEHOLDER: 'Conferma'
    },
    COUNTRY: {
      LABEL: 'Paese'
    },
    EMAIL: {
      LABEL: 'Indirizzo e-mail',
      PLACEHOLDER: 'votre@email.com'
    },
    FIRST_NAME: {
      LABEL: 'Nome',
      PLACEHOLDER: 'Il tuo nome'
    },
    LANGUAGE: {
      LABEL: 'Lingua'
    },
    LAST_NAME: {
      LABEL: 'Cognome ',
      PLACEHOLDER: 'Il tuo cognome'
    },
    NEW_PASSWORD: {
      LABEL: 'Nuova password',
      PLACEHOLDER: 'La tua nuova password'
    },
    OLD_PASSWORD: {
      LABEL: 'Vecchia password',
      PLACEHOLDER: 'La tua vecchia password'
    },
    PASSWORD: {
      LABEL: 'Password',
      PLACEHOLDER: 'Password',
      VALIDATION: 'La password deve essere composta da minimo 8 caratteri.',
      WARNING: 'Attenzione, "qwertyuiop" e "123456789" NON sono password complesse\nProva la sicurezza della tua password qui: <1>https://howsecureismypassword.net</1>'
    },
    PHONE: {
      LABEL: 'Telefono',
      PLACEHOLDER: '+33600000000'
    },
    POSTAL_CODE: {
      LABEL: 'Codice postale',
      PLACEHOLDER: 'Il tuo codice postale',
      STREET_NUMBER: 'Numero civico'
    },
    STREET: {
      LABEL: 'Indirizzo',
      PLACEHOLDER: 'Via e numero civico'
    }
  },
  geofences: {
    CREATE: {
      HEADLINE: 'Imposta una zona'
    },
    EDIT: {
      DELETE_GEOFENCE: 'Elimina la zona',
      ENTRANCE_NOTIFICATION: 'Notifica di entrata nella zona',
      EXIT_NOTIFICATION: 'Notifica di uscita dalla zona',
      GEOCODE_LABEL: 'Utilizzare un indirizzo',
      GEOCODE_PLACEHOLDER: 'Scrivi qui l\'indirizzo',
      LOCATION: 'Posizione del centro della zona di sicurezza',
      NAME_INPUT: {
        LABEL: 'Nome della zona',
        PLACRHOLDER: 'Immetti nome della zona'
      },
      OUTDOORS: 'Area all\'aperto (parco, foresta, ecc.)',
      OUTDOORS_TOOLTIP: 'Il GPS è più preciso all\'aperto e di conseguenza le regole che determinano l\'invio di una notifica di entrata o uscita dalla zona sono diverse per una zona all\'aperto rispetto a una zona al chiuso.',
      POINT_ON_THE_MAP_TEXT: 'o clicca direttamente sulla mappa',
      RADIUS: 'Dimensioni della zona (raggio)',
      TRACKER_LAST_POSITION_BUTTON: 'Utilizza la posizione del localizzatore',
      UNKNOWN_ADDRESS: 'Indirizzo sconosciuto'
    }
  },
  header: {
    ALL_TRACKERS: 'Tutti i localizzatori',
    AVAILABLE_PLURAL: 'disponibile/i',
    NAV: {
      ACCOUNT: 'Conto',
      INSURANCE: 'Assicurazione',
      LOGOUT: 'Disconnessione',
      SUPPORT: 'Assistenza',
      TRACKERS: 'Mappa'
    },
    SEARCHBAR_RESULT: 'localizzatori trovati',
    SEARCHBAR_TITLE: 'Ricerca un localizzatore',
    TRACKERS: 'localizzatore/i',
    WHITE_LABEL: {
      IN_PARTERNSHIP_WITH: 'In partnership con'
    }
  },
  imeiInfo: {
    HINT: 'Il numero IMEI è indicato sul retro del tuo localizzatore.',
    IMAGE_ALT: 'Foto del localizzatore',
    TITLE: 'Numero IMEI'
  },
  login: {
    FORGOT_PASSWORD: 'Hai dimenticato la password?',
    LOGIN_ERRORS: {
      UNKNOWN: 'Impossibile effettuare l\'accesso'
    },
    SIGN_IN_BUTTON: 'Accedi',
    SIGN_IN_HEADLINE: 'Accedi',
    SIGN_UP_BUTTON: 'Crea un account',
    SIGN_UP_HEADLINE: 'Non hai ancora un account?',
    TERMS_LINK: 'Condizioni di utilizzo',
    TERMS_LINK_URL: 'https://www.weenect.com/common/pdf/en/cgv-weenect.pdf'
  },
  manageSubscription: {
    CANCEL: {
      DESCRIBE_YOUR_PROBLEMS: 'Potresti precisare il motivo della cancellazione dell\'abbonamento?',
      GIVE_US_DETAILS: 'Motivo della disdetta abbonamento.',
      REASONS: {
        AFTER_SALES_SERVICE: 'Esperienza negativa con il Servizio clienti',
        BATTERY: 'Autonomia batteria insufficiente',
        LOST_BROKEN: 'L’ho smarrito/rotto',
        MOBILE_APPLICATION: 'L\'applicazione non funziona',
        NOT_SATISFIED: 'Non sono soddisfatto di Weenect',
        NO_USE: 'Non mi occorre più',
        TOO_EXPENSIVE: 'L’abbonamento è troppo costoso',
        TRACKER_FORMAT: 'Formato del localizzatore da rivedere (dimensioni e peso)',
        WILL_REACTIVATE_LATER: 'Riattiverò l\'abbonamento più tardi'
      },
      SAD_TO_SEE_YOU_LEAVE: 'Siamo tristi che te ne vai...',
      WHY_DO_YOU_RESIGN: 'Per quale motivo vuoi annullare l\'abbonamento?'
    },
    CANCEL_EXPIRE: 'Il rinnovo automatico è stato annullato. L\'abbonamento scadrà il {{date}}.',
    CANCEL_QUESTION: 'Non desideri restare abbonato?',
    CANCEL_RENEWAL: 'Annulla il rinnovo automatico',
    CANCEL_RENEWAL_BIS: 'Disdire l\'abbonamento',
    CANT_RESIGN_UNDER_EXTENDED_NOTICE: 'Desideri disdire il tuo abbonamento o semplicemente disattivare il rinnovo automatico?\nChiamaci al numero +33 (0)1 87 66 98 71 dalle 9:30 alle 16:00 dal lunedì al venerdì.',
    CANT_RESIGN_UNDER_NOTICE: 'Non è possibile annullare l\'abbonamento negli ultimi 30 giorni. Si prega di contattare il team di assistenza clienti.',
    CANT_RESIGN_UNTIL: 'Non può disdire il suo abbonamento prima del {{date}}',
    CANT_RESIGN_WHILE_COMMITED: 'Sei impegnato per 3 mesi, la cessazione del suo abbonamento avrà effetto solo alla fine del periodo in corso, cioè il {{date}}',
    CURRENT_PLAN: 'Abbonamento attuale',
    HEADLINE: 'Gestisci il tuo abbonamento',
    MESSAGES: {
      UPDATE_SUCCESS: 'Abbonamento aggiornato correttamente.'
    },
    RENEW_SUBSCRIPTION: 'Rinnova l\'abbonamento',
    RESIGN_DATE: 'La cessazione del tuo abbonamento avrà effetto alla fine del periodo corrente, che è {{date}}',
    RESUMPTION_DATE: 'Scegliete una data di ripresa',
    RETURN_TO_TRACKERS: 'Torna alla mappa'
  },
  map: {
    NO_GPS_MARKER_TITLE: 'Nessun segnale GPS',
    POSITION: 'Posizione'
  },
  mapControls: {
    MAP_TYPE: 'Tipo di mappa',
    REFRESH_POSITION: 'Aggiorna la posizione',
    SUPER_LIVE: 'Superlive',
    ZOOM_IN: 'Zoom +',
    ZOOM_OUT: 'Zoom -'
  },
  mapLayers: {
    CLASSIC_MAPS: 'Mappe standard',
    DONT_SUBSCRIBE: 'Continua con le mappe classiche',
    FOREST_PATH: 'Strade forestali e sentieri',
    GOOGLE_STREET: 'Google Maps',
    GRAY: 'Mappa in bianco e nero',
    PLAN: 'Mappa',
    PREMIUM_MAPS: 'Mappe Premium',
    PREMIUM_SUBSCRIBE: 'Attivare l\'opzione Mappe Premium',
    PREMIUM_WARNING_MSG: 'Ooops, non hai sottoscritto l\'opzione mappe Premium per il momento!\n\nQuest\'opzione ti consentirà di usufruire di mappe più complete e aggiornate regolarmente per osservare meglio gli spostamenti del localizzatore. \u2028Le versioni Satellite HD, Mappa dei rilievi, o sentieri forestali ti consentiranno di individuare il localizzatore rapidamente.\n\nAttiva questa opzione a soli {{mapOptionPrice}} / mese!',
    RELIEF: 'Rilievi',
    SATELLITE: 'Mappa satellitare',
    STREET: 'Classiche',
    UNLOCK_MAPS: 'Sblocca altre mappe cliccando su di esse!'
  },
  misc: {
    LANGUAGE: {
      DE: 'Tedesco',
      EN: 'Inglese',
      ES: 'Spagnolo',
      FR: 'Francese',
      IT: 'Italiano',
      NL: 'Olandese'
    },
    NO_DATE: 'Nessuna posizione conosciuta',
    ROTATE_DEVICE: 'Weenect è stato progettato per essere utilizzato in modalità verticale. Per approfittare al meglio dei nostri servizi, ti invitiamo a ruotare il dispositivo.',
    locale: 'it-IT'
  },
  onboarding: {
    ACTIVATING_HINT: 'Durata media di attivazione: 5 minuti',
    ACTIVATING_INDICATOR: 'Attivazione in corso',
    GREET: {
      BUTTON: 'Il localizzatore è acceso',
      COMMON_TEXT: 'Per iniziare bene, ti raccomandiamo di seguire le istruzioni del seguente tutorial. Ti aiuterà ad acquistare dimestichezza con il localizzatore.\n\nComincia con la messa in funzione del localizzatore. Segui le indicazioni qui sotto per accenderlo:',
      MAIN_TITLE: 'Informazioni di contatto',
      RED_TEXT: 'Per riuscire ad ottenere una posizione GPS, il localizzatore deve stare all\'esterno'
    },
    MAP_INTERACTIONS: {
      COMMON_TEXT: {
        PET: 'Dall\'alto in basso questi pulsanti ti consentono di far suonare o vibrare il localizzatore. Queste funzionalità ti consentono di educare l\'animale al richiamo.',
        SILVER: 'Dall\'alto in basso questi pulsanti ti consentono di far suonare o vibrare il localizzatore. '
      },
      TITLE: 'I pulsanti d\'interazione con il localizzatore'
    },
    MAP_INTERVAL: {
      COMMON_TEXT: 'Questo pulsante consente di scegliere con quale frequenza vuoi ricevere una nuova posizione GPS per il localizzatore.  Attenzione, più l\'intervallo è breve e meno l\'autonomia del localizzatore sarà elevata. ',
      TITLE: 'L\'intervallo di tempo tra ogni posizione GPS'
    },
    MAP_OPTIONS: {
      COMMON_TEXT: 'Questi pulsanti consentono di modificare il tipo di carta che si desidera visualizzare e di ingrandire o rimpicciolire.',
      TITLE: 'I pulsanti di regolazione della carta'
    },
    MAP_UPDATE: {
      COMMON_TEXT: 'Questo pulsante ti consente di aggiornare la posizione del localizzatore (per ottenere una nuova posizione il localizzatore deve essere collegato al server e avere un segnale GPS valido).',
      TITLE: 'Il pulsante di aggiornamento della posizione'
    },
    MODAL: {
      BUTTON_HINT: 'Premi il pulsante per 3 secondi fino a quando il localizzatore inizia a vibrare.',
      HEADLINE: 'Accendi il localizzatore all\'esterno o sul davanzale di una finestra',
      IMAGE_ALT: 'Foto del localizzatore',
      MAP_HINT: 'Una volta acceso, il localizzatore sarà visualizzato sulla mappa in media dopo 5 minuti.'
    },
    REMOTE_ASSISTANCE: {
      ASSISTANCE: {
        COMMON_TEXT: 'Se nessuno reagisce in questo intervallo, l\'avviso viene trasferito a un operatore'
      },
      EXPLANATION: 'L\'operatore prende in carico la chiamata e si occupa di assistere la persona che indossa il localizzatore. A seconda della situazione, può <1> contattare i famigliari o chiamare i soccorsi</1>.',
      PRICE: 'Questa opzione ha un costo mensile di 9,99 € e può essere disattivata in qualsiasi momento.',
      SOS: {
        COMMON_TEXT: 'Il tuo famigliare preme il pulsante SOS del suo localizzatore.'
      },
      TIME: {
        COMMON_TEXT: 'Tu ricevi un avviso e hai 30 secondi per rispondere.'
      },
      TITLE: 'Scopri la nostra nuova opzione: la teleassistenza ',
      USE_CASE: 'Questa opzione consente di mettere la persona che indossa il localizzatore in contatto con un servizio di teleassistenza specializzato, disponibile 7 giorni su 7 e 24 ore su 24.'
    },
    SIDE_PAGES: {
      COMMON_TEXT: {
        PET: 'Nella parte a sinistra, puoi trovare tutte le pagine per la gestione e l\'utilizzo del localizzatore. La scheda Cronologia ti consente di consultare gli spostamenti dell\'animale e la scheda Follow-up attività di conoscere i consumi di energia. La scheda Zone ti consente di configurare le diverse zone, la scheda Parametri contiene il profilo dell\'animale e la scheda Abbonamento consente di gestire in modo semplice e rapido l\'abbonamento e le opzioni.',
        SILVER: 'Nella parte a sinistra, puoi trovare tutte le pagine per la gestione e l\'utilizzo del localizzatore. La scheda Cronologia consente di consultare gli spostamenti della persona e la scheda Zone consente di configurare dei perimetri di sicurezza.\n La scheda Parametri consente di configurare il numero da chiamare in caso di SOS e i messaggi associati a ogni pulsante laterale del localizzatore. Infine, la scheda Abbonamento consente di gestire in modo semplice e rapido l\'abbonamento e le opzioni.'
      },
      TITLE: 'Pagine aggiuntive'
    },
    SKIP: 'Salta il tutorial',
    SUPERLIVE: {
      COMMON_TEXT: 'Questo pulsante ti consente di attivare la modalità "superlive": una nuova posizione ogni 10 secondi per 5 minuti.',
      TITLE: 'Il pulsante "superlive"'
    },
    TUTORIAL_START: {
      BUTTON: 'Prosegui il tutorial',
      COMMON_TEXT: 'Congratulazioni, il tuo localizzatore è pronto per l\'uso! Continuiamo con una rapida panoramica della tua area personale My Weenect.'
    },
    WAITING_GPS_POSITION: 'Ricerca di una posizione GPS',
    WAITING_GPS_POSITION_HINT: 'Accendi il localizzatore all\'esterno'
  },
  optionCardExpired: {
    PROPOSAL: 'Aggiorna la tua carta di credito per continuare ad usufruire dei nostri servizi.',
    UPDATE_CARD: 'Aggiorna adesso',
    WARNING: '<1>Attenzione!</1> Non puoi sottoscrivere quest\'opzione perché la tua <1>carta di credito è scaduta</1>.'
  },
  payment: {
    ADD_NEW_PAYMENT_REGULARISE: 'Registra un nuovo metodo di pagamento o regolarizza la tua situazione.',
    EXPIRACY_CREDIT_CARD_TEXT: 'Aggiungi un nuovo metodo di pagamento per regolarizzare la tua situazione.',
    NO_PAYMENT_MEAN_YET: 'Nessun mezzo di pagamento al momento',
    NO_PAYMENT_YET: 'Nessun mezzo di pagamento al momento',
    UPDATE_PAYMENT_REGULARISE: 'Se vuoi continuare a utilizzare il tuo localizzatore, ti preghiamo di aggiornare o cambiare il tuo metodo di pagamento.',
    WARNING_ERROR: 'Sembra che ci sia un problema con il tuo metodo di pagamento.',
    WARNING_EXPIRACY_CREDIT_CARD: 'Attenzione, la carta di credito è scaduta.',
    WARNING_NOT_ENOUGH_FOUNDS: 'Attenzione, sembra che non ci siano fondi sufficienti sul tuo conto.'
  },
  payments: {
    CARD: {
      ACCEPTED: '(CB, VISA, Mastercard, American Express)',
      DESCRIPTION: '30 giorni di garanzia soddisfatti o rimborsati',
      NAME: 'Carta di credito'
    },
    STATUS: {
      CANCELED: 'Annullato',
      ERROR: 'Non riuscito',
      NEW: 'Elaborazione in corso',
      PAYMENT_ERROR: 'Pagamento non riuscito',
      PAYMENT_ERROR_EXPLAIN_TEXT: 'Si è verificato un errore con il tuo pagamento. Ti preghiamo di riprovare tra qualche istante o contattare',
      PAYMENT_RETRY: 'Provare di nuovo',
      PAYMENT_SAV: 'servizio clienti.',
      PAYMENT_SUCCESS: 'Pagamento andato a buon fine!',
      PAYMENT_SUCCESS_TEXT: 'Il tuo pagamento è stato registrato. Ora puoi dare inizio alla tua esperienza Weenect!',
      PAYMENT_SUCCESS_TEXT_APP: 'Il tuo pagamento è stato registrato.',
      PENDING: 'Elaborazione in corso',
      REFUNDED: 'Rimborsato',
      SUCCESS: 'Confermato'
    },
    TRANSFER: {
      DESCRIPTION: '15 giorni in più per cambiare idea: 30 giorni di garanzia soddisfatti o rimborsati',
      NAME: 'Prelievo bancario'
    }
  },
  periods: {
    ALT: {
      MONTH: '1 mese',
      YEAR: '1 anno',
      YEAR_plural: '{{count}} anni'
    },
    BASE: {
      MONTH: 'mese',
      YEAR: 'anno'
    }
  },
  popup: {
    premium_pack_popup_flash_description_1_web: 'Luce fissa, oltre al lampeggio già incluso.',
    premium_pack_popup_flash_description_2_web: 'E un\'illuminazione fino a 30 minuti senza interruzioni.',
    premium_pack_popup_flash_title_web: 'Un altro stile di torcia, per ancora più sicurezza (*solo su Localizzatore XS e XT)',
    premium_pack_popup_map_description_1_web: 'Vista satellite in HD, rilievi, sentieri nel bosco e percorsi di trekking',
    premium_pack_popup_map_title_web: 'Altre mappe per adattarti a tutti i terreni',
    premium_pack_popup_notifications_description_1_web: 'Aggiungi fino a 10 contatti',
    premium_pack_popup_notifications_description_2_web: 'Credito di 40 SMS al mese.',
    premium_pack_popup_notifications_description_3_web: 'Oltre alle notifiche push e alle email, già incluse.',
    premium_pack_popup_notifications_title_web: 'Tutti gli avvisi sul tuo telefono, anche senza connessione internet',
    premium_pack_popup_ring_vibrate_description_1_web: 'Invece di 10 secondi senza il pacchetto Premium.',
    premium_pack_popup_ring_vibrate_title_web: 'Suoneria e vibrazione fino a 30 secondi',
    premium_pack_popup_superlive_description_1_web: 'Invece di 2 minuti senza il pacchetto Premium.',
    premium_pack_popup_superlive_title_simplified_web: 'Superlive fino a 30 minuti senza interruzioni'
  },
  powersavingarea: {
    ACTIVE_STATE: 'Attivo',
    INACTIVE_STATE: 'Inattivo',
    REDIRECT_APPLICATION: 'La modifica, la creazione delle zone e l’attivazione della modalità aereo vengono effettuate direttamente dall’app mobile Weenect.'
  },
  premium_pack_popup_flash_description_1: 'Luce fissa, oltre al lampeggio già incluso.',
  premium_pack_popup_flash_description_2: 'E un\'illuminazione fino a 30 minuti senza interruzioni.',
  premium_pack_popup_flash_title: 'Un altro stile di torcia, per ancora più sicurezza (*solo su Localizzatore XS e XT)',
  premium_pack_popup_map_description_1: 'Vista satellite in HD, rilievi, sentieri nel bosco e percorsi di trekking',
  premium_pack_popup_map_title: 'Altre mappe per adattarti a tutti i terreni',
  premium_pack_popup_notifications_description_1: 'Aggiungi fino a 10 contatti',
  premium_pack_popup_notifications_description_2: 'Credito di 40 SMS al mese.',
  premium_pack_popup_notifications_description_3: 'Oltre alle notifiche push e alle email, già incluse.',
  premium_pack_popup_notifications_title: 'Tutti gli avvisi sul tuo telefono, anche senza connessione internet',
  premium_pack_popup_ring_vibrate_description_1: 'Invece di 10 secondi senza il pacchetto Premium.',
  premium_pack_popup_ring_vibrate_title: 'Suoneria e vibrazione fino a 30 secondi',
  premium_pack_popup_superlive_description_1: 'Invece di 2 minuti senza il pacchetto Premium.',
  premium_pack_popup_superlive_title_simplified: 'Superlive fino a 30 minuti senza interruzioni',
  premium_pack_popup_title: '<strong>Accedi gratuitamente</strong> al pacchetto Premium',
  registerSummaryTable: {
    BILLED_MONTH: 'Il pagamento è mensile',
    BILLED_NOW: 'Fatturazione immediata',
    BILLED_THREE_YEARS: 'Il pagamento avviene una volta ogni tre anni.',
    BILLED_TWO_YEARS: 'Fatturato ogni due anni',
    BILLED_YEAR: 'Il pagamento viene effettuato una volta all’anno',
    HINT_OPTIONS_PRICE: 'Le opzioni, pari a un importo totale di {{amount}}, saranno fatturate a parte (non con l\'abbonamento) entro due ore.',
    OPTION_UPGRADE: 'Aggiungi l\'opzione {{name}} per soli {{price}} / {{period}}',
    PAY_HINT: 'Clicca sul pulsante "Paga e attiva" e paga {{subscriptionPrice}} per l\'abbonamento.',
    SUBSCRIPTION_UPGRADE: 'Passa a un abbonamento per due anni e risparmia {{amount}} ogni anno.',
    TOTAL: 'Prezzo totale'
  },
  registerTracker: {
    BUY_LINK: 'Non hai ancora un localizzatore Weenect? <1>Puoi acquistarne uno qui</1>',
    ERRORS: {
      UNKNOWN: 'Si è verificato un problema durane l\'attivazione del localizzatore, ti preghiamo di riprovare.'
    },
    HEADLINE: 'Attiva un nuovo localizzatore',
    IMEI_INPUT: {
      LABEL: 'Numero IMEI',
      PLACEHOLDER: 'Il numero IMEI è indicato sul retro del tuo localizzatore.'
    },
    NAME_INPUT: {
      LABEL: 'Nome del localizzatore',
      PLACEHOLDER: 'Nome del localizzatore'
    }
  },
  remoteAssistance: {
    BASE: 'Teleassistenza',
    FEATURES: 'Se il bottone SOS viene premuto e tu non rispondi entro 30 secondi, l\'avviso SOS e la chiamata vocale saranno automaticamente trasmessi 7 giorni su 7 e 24 ore su 24 alla nostra centrale di teleassistenza. I nostri operatori sono autorizzati a contattare i soccorsi come la polizia o i servizi di emergenza medica.',
    FORM: {
      ADDRESS_INPUT: {
        LABEL: 'Indirizzo',
        PLACEHOLDER: 'Via e numero civico'
      },
      BACK: 'Annulla',
      CITY_INPUT: {
        LABEL: 'Città',
        PLACEHOLDER: ''
      },
      EXTRA_PHONE: {
        LABEL: 'Telefono alternativo (opzionale)',
        PLACEHOLDER: ''
      },
      HEADLINE: 'Iscrizione alla teleassistenza',
      NAME_INPUT: {
        LABEL: 'Nome completo',
        PLACEHOLDER: 'Nome COGNOME'
      },
      PHONE: {
        LABEL: 'Telefono',
        PLACEHOLDER: ''
      },
      POSTAL_CODE_INPUT: {
        LABEL: 'Codice postale',
        PLACEHOLDER: ''
      },
      SAVE: 'Conferma',
      TERMS: 'Ho letto e accetto i <1>Termini e condizioni</1> del servizio',
      TEXT: 'Inserisci i dati del tuo familiare (chi indossa il localizzatore). Consentiranno al nostro personale di venirgli/venirle in aiuto in caso di avviso SOS'
    },
    PENDING: {
      WAITING_FOR_CALL_TEST: 'Modulo d\'iscrizione confermato. In attesa della chiamata di prova.\nOra devi fare una chiamata di prova per finalizzare l\'attivazione dell\'opzione. Fai riferimento all\'email che ti è stata inviata per la procedura da seguire.',
      WAITING_FOR_RESIGN: 'Disattivazione dell\'opzione in corso.\nLa tua richiesta di disattivare l\'opzione è stata ricevuta correttamente. I nostri operatori si stanno occupando delle formalità amministrative. La disattivazione sarà effettiva tra poco.',
      WAITING_FOR_VALIDATION: 'Conferma modulo d\'iscrizione in corso. \nI nostri operatori stanno verificando i dati che hai indicato al momento della sottoscrizione dell\'opzione. Non appena questi dati saranno confermati potremo passare all\'ultima fase di attivazione dell\'opzione: sarà necessario effettuare una chiamata di prova per verificare che tutto funzioni correttamente.'
    },
    USER_PHONE: {
      TEXT: 'Inserisci i tuoi dati. Consentiranno al nostro personale di contattarti in caso di avviso SOS.'
    }
  },
  safetyarea: {
    REDIRECT_APPLICATION: 'La modifica e la creazione delle zone si fanno direttamente dall’app mobile Weenect.'
  },
  santevet: {
    ADVANTAGE: {
      FIRST: '<span>6 mesi di abbonamento a Weenect offerti</span> alla sottoscrizione',
      PROMO_CODE: 'con il codice',
      SECOND: '<span>20€ di prevenzione offerti/anno</span> oltre al pacchetto già incluso'
    },
    FOOTER: {
      BUTTON: 'Vedi i prezzi',
      TEXT: 'Continuando, accetti di essere contattato da Santévet.'
    },
    OFFERS: {
      BILL: {
        TEXT: 'Dal <span>60% al 100%</span> e fino a 2.500€/anno.',
        TITLE: 'Le tue spese rimborsate in caso di malattie e incidenti'
      },
      CROSS: {
        TEXT: 'Beneficia <span>gratuitamente</span> e <span>in qualsiasi momento</span> di un\'assistenza telefonica.',
        TITLE: 'Un servizio veterinario di emergenza 24/7'
      },
      MONEY_PUSH: {
        TEXT: 'SantéVet anticipa i tuoi costi <span>gratuitamente</span> al termine della consultazione.',
        TITLE: 'L\'anticipo delle tue spese veterinarie con Payvet'
      },
      SERINGE: {
        TEXT: '<span>Fino a 150€/anno</span> per cure preventive (vaccinazioni, antiparassitari, ecc).',
        TITLE: 'Un pacchetto di prevenzione incluso in tutte le offerte'
      },
      TITLE: 'I vantaggi di Santévet:'
    },
    SUBTITLE: 'e goditi vantaggi esclusivi',
    TITLE: 'Assicura {{name}} per solo {{amount}} €/mese',
    TITLE_WITHOUT_PRICE: 'Assicura {{name}} subito'
  },
  signup: {
    ALREADY_MEMBER_TEXT: 'Hai già un account?',
    CREATE_ACCOUNT_HEADLINE: 'Crea un account',
    LOGIN_TEXT: 'Connettarsi',
    MARKETING_AGREEMENT_TEXT: 'Accetto di ricevere offerte e promozioni dai partner di Weenect',
    RETRY: 'Provare di nuovo',
    SIGNUP_ERRORS: {
      EMAIL_ALREADY_EXISTS: 'Questo indirizzo e-mail è già associato a un account',
      POPIN_EMAIL_ALREADY_EXIST: '<1>Ops</1>, questo indirizzo e-mail sembra essere già utilizzato.',
      UNKNOWN: 'Impossibile effettuare l\'accesso, si prega di riprovare'
    },
    SIGN_IN_TEXT: 'Accedi',
    SUBMIT_BUTTON: 'Crea l\'account',
    TERMS_AGREEMENT_TEXT: 'Accetto <1>le condizioni di utilizzo</1> del servizio'
  },
  simInfo: {
    TITLE: 'Numero SIM'
  },
  subOptions: {
    CANCEL: {
      EXPIRATION_DATE: 'Questa opzione sarà sempre attiva fino al {{date}}',
      HEADLINE: 'Desideri annullare l\'opzione {{option}} ?'
    },
    MAP: {
      BASE: 'Pack multi mappe',
      FEATURES: 'Ottieni mappe più complete e aggiornate regolarmente per osservare meglio gli spostamenti del localizzatore. (Satellite HD, Mappe dei rilievi, Sentieri forestali)',
      TITLE: 'Mappe HD: '
    },
    PREMIUM: {
      BASE: 'Pacchetto Premium',
      BUTTON: {
        FREEMONTH: 'Provalo gratis per 1 mese!'
      },
      DEACTIVATE: 'Disattivando questa opzione si perderanno le prestazioni del premio.',
      FEATURE: {
        CHAT: {
          BASE: 'Chat on-line',
          TEXT: 'Chatta con un consulente Weenect direttamente dalla tua app. Servizio disponibile 7 giorni su 7, dalle ore 9.00 alle 18.00.'
        },
        SMS: {
          TEXT: 'Ricevi tutti gli avvisi via SMS ( credito di 40 SMS al mese incluso), oltre alle notifiche push e via e-mail già incluse nell\'abbonamento.'
        }
      },
      FEATURE_TEXT: 'Usufruite di vantaggi esclusivi (avvisi via SMS, mappe HD) all\'interno dell\'applicazione.',
      FREEMONTH: {
        BASE: 'Primo mese gratuito!',
        BASE2: 'GRATUITO'
      },
      SUBTITLE: 'Il Premium Pack include le seguenti caratteristiche:',
      SUB_LEGAL: 'L\'abbonamento sarà rinnovato automaticamente ogni mese, tramite il metodo di pagamento scelto al momento della sottoscrizione. È possibile annullare l\'iscrizione in qualsiasi momento tramite il proprio spazio personale.',
      TEXT_INFO_PRICE: 'Poi {{price}}/mese dopo il primo mese.',
      TITLE_DISCOVER: 'Scopri tutti i vantaggi esclusivi:',
      TITLE_POPUP: 'Passa a Premium!'
    },
    SMS_PACK: {
      ALT_FEATURES: {
        one: 'Ricevi tutti gli avvisi via SMS',
        other: ''
      },
      BASE: 'Pacchetto SMS',
      FEATURES: {
        one: 'Ricevi tutti gli avvisi via SMS (20 SMS disponibili al mese). Nota che senza tale opzione riceverai avvisi mediante notifiche push (applicazione) e email.',
        other: ''
      }
    },
    UNDEFINED: {
      PAYMENTS: 'Pagamento dell\'opzione'
    },
    WARRANTY: {
      ALT_FEATURES: {
        one: 'Ricevi gratuitamente un nuovo localizzatore in caso di rottura, smarrimento o furto del tuo attuale localizzatore.',
        other: 'Pagamento con carta di credito con possibilità di annullamento in qualsiasi momento',
        two: 'Il tuo localizzatore sostituito in 48H in caso di smarrimento, rottura o furto, senza condizioni.'
      },
      BASE: 'Copertura multirischio',
      EXPLAINER: 'La garanzia standard copre solo i difetti di fabbrica del localizzatore.',
      FEATURES: 'Ottieni un localizzatore sostitutivo gratuito in caso di danni, smarrimento o furto del tuo attuale localizzatore; non è richiesta alcuna motivazione. La garanzia standard copre esclusivamente i difetti di fabbricazione del localizzatore.'
    }
  },
  subscription: {
    ADD_A_PROMO_CODE: 'Aggiungi un codice promozionale',
    CANCEL_PAGE: {
      BUTTON: 'Riprova',
      TEXT: 'Il tuo pagamento è stato annullato',
      TITLE: 'Pagamento annullato'
    },
    COMMON_TEXT: {
      MONTH: '/ mese',
      OR: 'Cioè'
    },
    FAIL_PAGE: {
      BUTTON: 'Riprovare',
      TEXT: 'Il tuo pagamento non è andato a buon fine. Ti invitiamo a riprovare.',
      TITLE: 'Pagamento fallito'
    },
    FEATURES: {
      APP_ACCESS: 'Accesso illimitato all\'applicazione e al servizio di localizzazione',
      REFOUND: '15 giorni di prova: soddisfatti o rimborsati',
      SAV: 'Servizio clienti disponibile 6/7 giorni. \nRisposta garantita entro 24 ore.',
      WARRANTY: '24 mesi di garanzia del produttore'
    },
    FIRST_PAGE: {
      BUTTON: 'Successivo',
      BY_YEAR: 'Ovvero {{price}} all\'anno',
      FOR_YEAR: 'Ovvero {{price}} per {{period}} anni',
      MODAL_GIFT_CARD: {
        BUTTON: 'Applicare',
        DELETE_BUTTON: 'Remove',
        ERROR: 'Il numero della carta regalo inserito non è valido',
        INPUT_LABEL: 'Carta regalo',
        TITLE: 'Aggiungi una carta regalo'
      },
      MODAL_INFORMATION: {
        TEXT: 'La SIM card direttamente integrata nel tuo localizzatore richiede l\'abbonamento (per coprire i costi del servizio).',
        TITLE: 'Perché scegliere un abbonamento?'
      },
      SUBSCRIPTION_CGV: {
        FIRST_TEXT: 'Tutti gli abbonamenti vengono pagati in un’unica soluzione e rinnovati automaticamente in base al periodo scelto. Puoi annullare questo rinnovo in qualsiasi momento prima della fine del periodo in corso.',
        INCLUDES: {
          FIRST: 'soddisfatto o rimborsato',
          FIRST_BOLD: '15 o 30 giorni di prova minima a seconda dell\'abbonamento:',
          FOURTH: 'costruttore 24 mesi minimo',
          FOURTH_BOLD: 'Garanzia',
          SECOND: 'e al servizio di localizzazione illimitato.',
          SECOND_BOLD: 'Accesso all\'app',
          THIRD: 'disponibile 6/7 giorni. Risposta garantita entro 24 ore.',
          THIRD_BOLD: 'Servizio clienti'
        },
        SECOND_TEXT: 'Per beneficiare degli abbonamenti, devi inserire informazioni bancarie valide e accettare le',
        SECOND_TEXT_LINK: 'condizioni generali di utilizzo del servizio.',
        TITLE: 'Tutti gli abbonamenti includono:'
      },
      SUBSCRIPTION_CHOICE: {
        CHIP_BEST_OFFER: 'Migliore offerta',
        CHIP_ECO_OFFER: 'Offerta economica',
        CHIP_ONE_MONTH: 'Offerta flessibile',
        CHIP_ONE_YEAR: 'Offerta popolare',
        CHIP_POPULAR_OFFER: 'Offerta popolare',
        CHIP_THREE_YEAR: 'Risparmia {{count}}%',
        SEE_MORE: 'Vedi più abbonamenti',
        SUBSCRIPTION_TITLE_GIFT_CARD: 'Ho una carta regalo',
        SUBSCRIPTION_TITLE_MONTHLY: 'Abbonamento mensile',
        SUBSCRIPTION_TITLE_one: 'Abbonamento di {{count}} anno',
        SUBSCRIPTION_TITLE_other: 'Abbonamento di {{count}} anni',
        TIP_30_DAYS_WARRANTY: '🛡️ Soddisfatti o rimborsati: hai 30 giorni per cambiare idea.',
        TIP_ONE_MONTH: '💡 Risparmia il {{savings}}% e approfitta di 30 giorni di garanzia “soddisfatti o rimborsati” scegliendo l’abbonamento annuale.',
        TIP_ONE_YEAR: '💡 Risparmia il {{savings}}% scegliendo l’abbonamento di 3 anni.',
        TIP_THREE_YEAR: '🛡️ Garanzia "soddisfatti o rimborsati" estesa: hai 30 giorni per cambiare idea.',
        TIP_TWO_YEAR: '💡 Approfitta di un anno di abbonamento aggiuntivo per soli {{additional_cost}} in più scegliendo il piano da 3 anni.',
        TITLE: 'Scegli il tuo abbonamento'
      },
      SUBTITLE: 'Gli abbonamenti sono coperti dalla garanzia “soddisfatti o rimborsati”: hai 15 giorni per cambiare idea.'
    },
    FOR_MINUS_X_PERCENT: '{{percent}}% di sconto',
    FREE: 'GRATUITO',
    HEADER: {
      STEP: 'Passo',
      TITLE: {
        FIRST_PAGE: 'Abbonamento',
        SECOND_PAGE: 'Opzioni',
        THIRD_PAGE: 'Pagamento'
      }
    },
    HOME_PAGE: {
      TITLE: ''
    },
    INFO_CGU: 'Per beneficiare degli abbonamenti, è necessario inserire informazioni bancarie valide e accettare le condizioni generali',
    INFO_CGU_BUTTON: 'le condizioni generali di utilizzo del servizio.',
    INFO_OPTION: 'Il pagamento è mensile, la cancellazione è possibile in qualsiasi momento.',
    MANAGE_PAGE: {
      ACCOUNT_OPTIONS: {
        DESCRIPTION: 'Le opzioni dell\'account si applicano a tutti i tracker del tuo account.',
        PREMIUM_PACK: {
          DESCRIPTION: '- Superlive fino a 30 minuti senza interruzioni.\n- Mappe aggiuntive per adattarsi a qualsiasi terreno.\n- Tutti gli avvisi sul tuo telefono, anche senza connessione internet.',
          TITLE: 'Pacchetto Premium'
        },
        TITLE: 'Opzioni dell\'account',
        WARRANTY: {
          DESCRIPTION: '💡 Ottieni gratuitamente un localizzatore sostitutivo in caso di rottura, perdita o furto del tuo localizzatore attuale; non è richiesta alcuna giustificazione.',
          TITLE: 'Garanzia multirischio'
        }
      },
      ACTIVATE: {
        BUTTON: 'Attivare'
      },
      ADD_SUBSCRIPTION_BUTTON: 'Scegliere un abbonamento',
      CANCEL: {
        BUTTON: 'Disdire'
      },
      CANCEL_CONFIRM: {
        GENERIC: {
          BUTTON: {
            CONTINUE_CANCELLATION: 'Continua',
            KEEP_ADVANTAGES: 'Mantenere i miei vantaggi'
          },
          TITLE: 'Sei sicuro?'
        },
        OPTION: {
          PREMIUM_PACK: {
            SUBTITLE: 'Disattivando il rinnovo del pacchetto premium, perderai i seguenti vantaggi a partire dal {{date}}:'
          },
          WARRANTY: {
            SUBTITLE: 'Disattivando il rinnovo della garanzia multirischi, perderai i seguenti vantaggi a partire dal {{date}}:'
          }
        },
        SUBSCRIPTION: {
          ADVANTAGES: {
            DESCRIPTION: '- Accesso ai servizi Weenect per questo tracker\n- Garanzia del produttore a vita per il tuo tracker'
          },
          SUBTITLE: 'Disattivando il rinnovo del tuo abbonamento, perderai i seguenti vantaggi a partire dal {{date}}:'
        }
      },
      EDIT: {
        BUTTON: 'Modificare',
        CANCEL_REVIEW: {
          OPTION: {
            SUBTITLE: {
              PREMIUM_PACK: 'Ci dispiace vederti andare.\nPer quale motivo desideri annullare il rinnovo del tuo pacchetto premium?',
              WARRANTY: 'Ci dispiace vederti andare.\nPer quale motivo desideri annullare il rinnovo della tua garanzia multirischi?'
            },
            TITLE: 'Disattivare il rinnovo dell’opzione'
          },
          REASON: {
            AFTER_SALES_SERVICE: '',
            BAD_PRECISION: '',
            BATTERY: '',
            LOST_BROKEN: '',
            MISSING_FEATURES: '',
            MOBILE_APPLICATION: '',
            NOT_ENOUGH_FEATURES_PREMIUM: '',
            NOT_SATISFIED: '',
            NO_USE: '',
            OTHER: '',
            PLACEHOLDER: '',
            TOO_EXPENSIVE: '',
            TOO_EXPENSIVE_OPTION: '',
            TRACKER_FORMAT: '',
            WILL_REACTIVATE_LATER: ''
          },
          SUBSCRIPTION: {
            SUBTITLE: 'Ci dispiace vederti andare.\nPer quale motivo desideri annullare il rinnovo del tuo abbonamento?',
            TITLE: 'Disattivare il rinnovo dell’abbonamento'
          }
        },
        ERROR: {
          HEADER: 'Errore',
          SUBTITLE: 'La modifica del tuo abbonamento non è riuscita. Riprova.\nSe il problema persiste, contatta il nostro servizio clienti.',
          TITLE: 'Ops, si è verificato un problema.'
        }
      },
      EDIT_OPTION: {
        HEADER: 'Modificare l’opzione'
      },
      EDIT_SUBSCRIPTION: {
        CANCEL: {
          SUBTITLE: 'Il tuo abbonamento non verrà più rinnovato automaticamente. Perderai l’accesso ai tuoi servizi il {{date}}.',
          TILE: 'Disattivare il rinnovo',
          TITLE: 'Disattivare il rinnovo?'
        },
        CHANGE: {
          SUBTITLE: 'Il cambio di abbonamento verrà effettuato alla fine del periodo in corso.',
          SUCCESS: {
            BUTTON: 'Torna al menu',
            SUBTITLE_1: 'Il tuo abbonamento verrà rinnovato con la seguente formula:',
            SUBTITLE_2: 'La fatturazione e il rinnovo con questa formula avverranno il {{date}}.',
            TITLE: 'Modifica dell’abbonamento registrata!'
          },
          TITLE: 'Cambiare abbonamento?'
        },
        HEADER: 'Modificare l\'abbonamento'
      },
      FIRST_MONTH_FREE: '1º mese gratuito',
      NO_SUBSCRIPTION: 'Questo tracker non ha alcun abbonamento.',
      OPTION_STATUS: {
        ACTIVE: {
          DESCRIPTION: 'Questa opzione è attiva e verrà rinnovata automaticamente il {{date}} per {{period}} al prezzo di {{price}}.',
          DESCRIPTION_PAST: 'Questa opzione è attiva e verrà presto fatturata per {{period}} a {{price}}.',
          TITLE: 'Rinnovo automatico attivo'
        },
        ACTIVE_NO_DATE: {
          DESCRIPTION: 'Questa opzione è attiva.'
        },
        CANCELED: {
          DESCRIPTION: 'Il rinnovo di questa opzione è disattivato. L’accesso alle funzionalità rimane possibile fino al {{date}}, ma dopo tale data non saranno più disponibili.',
          TITLE: 'Rinnovo automatico disattivato'
        },
        EXPIRED: {
          DESCRIPTION: 'Questa opzione è scaduta. Ti preghiamo di riattivarla per riottenere l’accesso alle funzionalità associate.'
        }
      },
      REACTIVATE: {
        BUTTON: 'Riattivare il rinnovo'
      },
      SUBSCRIBE_AGAIN: {
        BUTTON: 'Abbonarsi di nuovo'
      },
      SUBSCRIPTION_STATUS: {
        ACTIVE: {
          DESCRIPTION: 'Il tuo abbonamento verrà rinnovato automaticamente il {{date}} per {{period}} a {{price}}.',
          DESCRIPTION_PAST: 'Il tuo abbonamento verrà presto fatturato per {{period}} a {{price}}.',
          TITLE: 'Rinnovo automatico attivo'
        },
        CANCELED: {
          DESCRIPTION: '',
          TITLE: 'Rinnovo automatico disattivato'
        },
        EXPIRED: {
          DESCRIPTION: 'Il tuo abbonamento è scaduto.\nDevi attivare un nuovo abbonamento per poter utilizzare questo localizzatore.'
        }
      },
      TITLE: 'Abbonamento/i e opzioni',
      TRACKER_SUBSCRIPTIONS_OPTIONS: {
        TITLE: 'Abbonamento e opzioni di {{name}}'
      }
    },
    MONEY_BACK: 'Tutti gli abbonamenti sono fatturati immediatamente ma possono essere annullati entro 15 giorni, con un rimborso completo dell\'importo pagato.',
    MONTH: 'Mese',
    ONLY: 'solo',
    PAYMENT_INFO: 'Garanzia di rimborso: 15 giorni per provare il tuo localizzatore',
    PAYMENT_SUBHEADLINE: 'Seleziona un metodo di pagamento per pagare il tuo abbonamento e attivare il tuo localizzatore.',
    PAYMENT_TITLE: 'Scegli il tuo metodo di pagamento',
    PAYMENT_TITLE2: 'Registrate il vostro metodo di pagamento',
    PENDING_PAGE: {
      BUTTON: 'Annulla',
      TEXT: 'La convalida del pagamento è in corso ...',
      TIMEOUT_TEXT: 'La convalida del pagamento sembra richiedere più tempo del previsto.',
      TITLE: 'Pagamento in corso'
    },
    PERIOD: {
      MONTH_one: '{{period}} mese',
      MONTH_other: '{{period}} mesi',
      YEAR_one: '{{period}} anno',
      YEAR_other: '{{period}} anni'
    },
    PREPAYED: '{{price}} pagati in un’unica soluzione',
    PREPAYED_DATE: '{{price}} pagati in un’unica soluzione il {{date}}',
    PRICE_MONTH_SAVED: 'cioè {{price}} / mese',
    SECONDE_PAGE: {
      BUTTON: 'Procedi al pagamento'
    },
    SECOND_PAGE: {
      BASKET: {
        TEXT: {
          premium_pack: 'Primo mese gratuito, poi',
          warranty: 'Il pagamento è mensile.'
        },
        TOTAL: 'Totale IVA inclusa'
      },
      OPTION_CHOICE: {
        CHIP: '1° mese gratuito',
        TEXT: {
          premium_pack: 'Sblocca funzionalità esclusive: Superlive fino a 30 minuti, visualizzazioni di mappe aggiuntive, un altro stile di torcia, oppure avvisi tramite SMS.',
          warranty: 'Ottieni gratuitamente un localizzatore sostitutivo in caso di rottura, perdita o furto del tuo localizzatore attuale; non è richiesta alcuna giustificazione.'
        },
        TITLE: {
          premium_pack: 'Pacchetto Premium',
          warranty: 'Garanzia multirischio'
        }
      },
      SUBTITLE: 'Le opzioni sono senza impegno e possono essere annullate in qualsiasi momento dall’app mobile o dall’area clienti.',
      TITLE: 'Scegli le tue opzioni'
    },
    SUBSCRIPTION_TITLE: {
      MONTH_one: 'Abbonamento mensile',
      MONTH_other: 'Abbonamento di {{period}} mesi',
      YEAR_one: 'Abbonamento annuale',
      YEAR_other: 'Abbonamento di {{period}} anni'
    },
    SUCCESS_PAGE: {
      BUTTON: 'Torna all\'app',
      TEXT: 'Fai clic sul pulsante qui sotto per iniziare a usare il tuo localizzatore.',
      TEXT_ASYNC: 'L’addebito verrà effettuato tra qualche giorno.\n\n⚠️ In caso di rifiuto da parte della banca, il localizzatore verrà disattivato.\n\nClicca sul pulsante qui sotto per iniziare a usare il tuo localizzatore.',
      TITLE: 'Pagamento registrato'
    },
    SUMMARY: 'Riassunto',
    THIRD_PAGE: {
      BUTTON: 'Conferma e paga',
      MODAL: {
        ERROR: 'Il codice promozionale non è valido',
        TITLE: 'Codice promozionale'
      },
      NO_PROVIDER: 'Nessun metodo di pagamento disponibile',
      PAYMENT_CHOICE: {
        BANK: 'Addebito diretto',
        CARD: 'Carta di credito',
        TITLE: 'Scegli il tuo metodo di pagamento'
      },
      SUBTITLE: 'Seleziona un metodo di pagamento per pagare il tuo abbonamento e attivare il tuo localizzatore.'
    },
    UNKNOWN_PAGE: {
      BUTTON: 'Torna all\'applicazione',
      TEXT: 'L\'applicazione si è trovata in uno stato imprevisto.',
      TITLE: 'Passo sconosciuto'
    }
  },
  subscriptionAlert: {
    ACTIVATE_AUTO_RENEWAL: 'Riattiva il rinnovo automatico',
    AUTO_RENEWAL_ADVICE: 'Ti consigliamo di riattivare il rinnovo automatico se vuoi prolungare l\'abbonamento.',
    AUTO_RENEWAL_NOTICE: '<1>Attenzione!</1> Il tuo abbonamento per il localizzatore {{trackerName}} sta per scadere e il rinnovo automatico è disattivato.',
    CONTINUE_BUTTON: 'Continua',
    MESSAGES: {
      UPDATE_ERROR_UNKNOWN: 'Si è verificato un problema',
      UPDATE_SUCCESS: 'Dati aggiornati correttamente'
    },
    REMIND_LATER: 'Ricordamelo più tardi',
    SUPPORT_TEXT: 'Se hai domande o pensi che si tratti di un errore, contatta il nostro <1>servizio clienti.</1>',
    TRIAL_CASE: {
      SUBSCRIBE_BUTTON: 'Sottoscrivi un abbonamento',
      TRIAL_IS_OVER: 'Il periodo di prova è terminato',
      TRIAL_IS_OVER_ADVICE: 'Ci auguriamo che la prova sia stata un successo! Per continuare a utilizzare il prodotto, è necessario sottoscrivere un abbonamento.'
    }
  },
  subscriptionOptionsSelection: {
    CANCEL_WARNING_MODAL_HEADLINE: 'Vuoi davvero disattivare questa opzione?',
    CANCEL_WARNING_SMS: 'Disattivando questa opzione non riceverai le notifiche degli avvisi per SMS.',
    CANCEL_WARNING_WARRANTY: 'Disattivando questa opzione perderai la protezione supplementare della garanzia multi-rischio.',
    EXPLANATION: 'Le opzioni sono selezionate per default ma puoi deselezionarle cliccando qui sotto.',
    EXPLANATION2: 'And cancellation is possible at any time.',
    EXPLANATION3: 'Non verrà effettuato alcun pagamento.',
    HINT: 'Puoi attivare o disattivare un\'opzione in qualsiasi momento',
    MAIN_HEADLINE: 'Scegli le tue opzioni',
    SUBMIT_BUTTON: 'Conferma'
  },
  subscriptionPayment: {
    ERRORS: {
      UNKNOWN: 'Si è verificato un problema al momento del pagamento, ti preghiamo di riprovare'
    },
    GIFT_CARD: {
      EXPLANATION: 'Inserisci il codice scritto dietro la carta regalo fornita nella scatola del localizzatore.',
      I_HAVE_ONE: 'Ho una carta regalo',
      NEED_HELP: 'Bisogno di aiuto a proposito della carta regalo?',
      TITLE: 'Usa il tuo regalo',
      USE: 'Usa carta regalo'
    },
    HEADLINE: 'Riepilogo prima del pagamento',
    PROMOCODE_TEXT: 'Ho un codice coupon:',
    PROMO_CODE: 'Codice promozionale',
    PROMO_CODE_GIFT_CARD: 'Carta regalo',
    SATISFIED_OR_REFUNDED: 'Garanzia soddisfatti o rimborsati',
    SATISFIED_OR_REFUNDED_DESCRIPTION: '30 giorni per provarlo senza rischi, se non sei soddisfatto ti rimborsiamo.',
    SELECT_PAYMENT_MEAN: 'Seleziona un metodo di pagamento prima di pagare e attivare l\'abbonamento. ',
    SUBMIT_BUTTON: 'Pagare l\'abbonamento',
    SUBMIT_BUTTON2: 'Attivare il localizatore',
    SUMMARY: 'Riepilogo ordine'
  },
  subscriptionProcess: {
    GIFT_CARD_EXPLANATION: 'Inserite il vostro metodo di pagamento preferito per attivare gratuitamente il vostro tracker.',
    GIFT_CARD_EXPLANATION2: 'Queste informazioni sono necessarie per motivi legali legati all\'uso delle carte SIM.',
    RETURN_TO_APP: 'Torna sull\'applicazione',
    RETURN_TO_MAP: 'Torna alla mappa',
    RETURN_TO_TRACKERS: 'Torna alla mappa',
    STEPS: [
      'Localizzatore',
      'Abbonamento',
      'Opzioni',
      'Riepilogo'
    ]
  },
  subscriptionSelection: {
    BEST_OFFER: 'OFFERTA MIGLIORE',
    CANCELABLE_AFTER_THREE_MONTHS: 'Possibilità di annullamento in qualsiasi momento dopo i primi tre mesi',
    CANCEL_ANYTIME: 'Possibilità di annullamento in qualsiasi momento',
    COMMITMENT_TEXT: 'Può essere terminato in qualsiasi momento dopo il periodo di impegno minimo di 3 mesi.',
    FEATURES: '',
    FEATURES_HEADLINE: 'Tutti gli abbonamenti comprendono:',
    HEADLINE: 'Scegli il tuo abbonamento',
    MIN_THREE_MONTHS: 'Impegno minimo di tre mesi',
    MONEY_BACK: 'Tutti gli abbonamenti sono fatturati immediatamente, ma possono essere annullati entro 30 giorni con un rimborso totale dell\'importo pagato.',
    PAYMENT_MEANS: 'Pagamento con addebito diretto o con carta di credito',
    REFUNDED_INFO: 'Ti rimborsiamo l\'abbonamento senza condizioni.',
    REFUNDED_TEXT: 'Soddisfatti o rimborsati per 30 giorni.',
    SIM_CARD_WARNING: 'Una carta sim è integrata direttamente nel tuo localizzatore. Ecco perché è necessario sottoscrivere un abbonamento (per coprire le spese di servizio).',
    SUBMIT_BUTTON: 'Conferma',
    XMAS_OFFER: {
      BODY: 'Tuttavia siamo obbligati a farle scegliere subito il suo futuro abbonamento (per motivi di sicurezza,  il prodotto è dotato di una carta SIM). Non lei verrà addebitato alcun costo prima della fine dei 6 mesi liberi e potrà disdire l\'abbonamento in qualsiasi momento fino a un mese prima della sua data di inizio effettiva.',
      TITLE: 'Il suo tracker è pre-caricato con 6 mesi di abbonamento offerto dal parente.'
    },
    features: [
      '30 giorni di garanzia soddisfatti o rimborsati',
      'Localizzazione GPS illimitata',
      'Notifiche push (applicazione) e per e-mail',
      '10 minuti di chiamate voce al mese'
    ]
  },
  subscriptions: {
    BASE: 'Abbonamento',
    CANCEL_MODAL: {
      HEADLINE: 'Desideri annullare il rinnovo automatico del tuo abbonamento?',
      HINT: 'Il tuo abbonamento sarà sempre attivo fino al {{date}}, ma non sarà rinnovato automaticamente alla scadenza. Dopo questa data non sarai più in grado di rintracciare il tuo localizzatore'
    },
    CHANGE_PLAN: {
      ADD_OPTIONS: 'Aggiungi un\'opzione',
      EXPLANATION: 'Il cambio di abbonamento sarà effettivo alla fine del periodo in corso.',
      HEADLINE: 'Cambiare abbonamento?'
    },
    DETAILS: {
      ACTIVATE_BUTTON: {
        LABEL: 'Attiva l\'abbonamento'
      },
      ACTIVE_CASE: {
        MANAGE_BUTTON: 'Gestisci il tuo abbonamento',
        RENEWAL_INFO: 'L\'abbonamento si rinnoverà automaticamente il {{date}} a {{price}}'
      },
      CANCELED: {
        EXPIRED_MAIN: 'Il tuo abbonamento è scaduto. Riattiva l\'abbonamento per poter rintracciare il localizzatore.',
        EXPIRED_SEC: 'Scaduto',
        UNCANCEL_BUTTON_LABEL: 'Riattivare il rinnovo automatico dell\'abbonamento',
        WILL_EXPIRE_DAYS: 'Scade tra {{count}} giorno',
        WILL_EXPIRE_DAYS_plural: 'Scade tra {{count}} giorni',
        WILL_EXPIRE_MAIN: 'Il rinnovo automatico del tuo abbonamento è stato annullato. Scadrà in data {{date}}.'
      },
      CANCEL_RESILLIATION: 'Annulla la richiesta di cancellazione',
      NEW_CASE: {
        INFO_TEXT: 'Si è verificato un problema con il pagamento. Ti preghiamo di riprovare o di cambiare metodo di pagamento.',
        PAY_BUTTON: 'Paga e attiva',
        WAITING_TEXT: 'Stiamo attualmente elaborando il pagamento per l\'abbonamento di questo tracker.'
      },
      NO_SUB: {
        INFO_TEXT: 'Attiva l\'abbonamento per iniziare a usare il tuo localizzatore.'
      },
      RESILLIATION_ASKED: 'Cancellazione richiesta',
      SUBSCRIBE_BUTTON: {
        LABEL: 'Sottoscrivi un abbonamento'
      },
      SUPPORT_TEXT: 'Hai dei problemi con l\'attivazione del tuo localizzatore? Contatta l\'<1>assistenza</1>',
      TRIAL_PERIOD_CASE: {
        END_INFO: 'Il periodo di prova terminerà il {{ date }}'
      }
    },
    OFFERS: {
      SAVING_PER_YEAR: 'risparmia {{amount}} / anno'
    },
    OFFERS_TEXT: {
      MOST_POPULAR: 'La più popolare',
      ONE_MONTH: {
        INFO: 'Nessun impegno, annullabile in qualsiasi momento',
        TITLE: 'Formula 1 mese'
      },
      ONE_YEAR: {
        INFO: '15 giorni di prova in più: 30 giorni in totale',
        TITLE: 'Formula 1 anno'
      },
      THREE_YEAR: {
        INFO: '1 anno aggiuntivo di garanzia del produttore: 3 anni in totale',
        INFO2: '3-year manufacturer\'s warranty (instead of two).',
        TITLE: 'Formula 3 anni'
      }
    },
    OVERVIEW: {
      OPTIONS: 'Dettagli delle opzioni',
      REG_DETAILS: 'Dettagli del localizzatore',
      REPLACE_TRACKER_BUTTON: {
        LABEL: 'Sostituzione del localizzatore'
      },
      SUB_DETAILS: 'Dettagli dell\'abbonamento'
    },
    PLAN_NAMES: {
      FALLBACK: 'Abbonamento',
      ONE_MONTH: 'Abbonamento mensile',
      ONE_YEAR: 'Abbonamento prepagato 1 anno',
      THREE_YEARS: 'Abbonamento prepagato 3 anni',
      TRIAL_PERIOD: 'Periodo di prova',
      TWO_YEARS: 'Abbonamento per 2 anni'
    },
    STATUS: {
      ACTIVE: 'Sottoscritto',
      CANCELED: 'Annullato',
      INACTIVE: 'Non sottoscritto',
      NEW: 'Attivo',
      PENDING: 'In attesa'
    },
    TRACKER_DETAILS: {
      REGISTRATION_DATE: 'Data di attivazione',
      WARRANTY: 'Garanzia standard'
    }
  },
  superLive: {
    ACTIVE_TEXT: 'La modalità Super live è attiva',
    HEADLINE: 'Modalità super live',
    MESSAGES: {
      SUCCESS_ACTIVATED: 'Modalità Super live attivata: il localizzatore invierà una posizione ogni {{frequency}} secondi per 5 minuti'
    },
    TIME: '1 posizione ogni {{frequency}} secondi'
  },
  support: {
    FORM: {
      MESSAGE: {
        LABEL: 'Il tuo messaggio*',
        PLACEHOLDER: ''
      },
      PROBLEM: {
        AVAILABLE_OPTIONS: 'Opzioni disponibili',
        LABEL: 'Tipo di problema riscontrato*'
      },
      SUBJECT: {
        LABEL: 'Oggetto della richiesta*',
        PLACEHOLDER: ''
      },
      TRACKER: {
        LABEL: 'Localizzatore a cui si riferisce la richiesta',
        PLACEHOLDER: 'Seleziona il localizzatore'
      }
    },
    HEADLINE: 'Assistenza',
    HELP_CENTER: 'Centro assistenza',
    HELP_TEXT: 'Serve aiuto? Puoi trovare la risposta alla tua domanda nel nostro centro d\'aiuto. Puoi anche contattarci utilizzando il modulo che trovi qui di seguito; il nostro team ti risponderà entro 24 ore lavorative.',
    MAIN_TEXT: 'Il nostro centro di assistenza contiene tutti gli articoli per rispondere alle tue domande.',
    MESSAGES: {
      SUBMIT_ERROR: 'Si è verificato un errore, ti preghiamo di riprovare',
      SUBMIT_SUCCESS: 'Messaggio inviato correttamente'
    },
    PROBLEM_TYPES: {
      CHARGE: 'Il mio localizzatore non si ricarica normalmente',
      DOWNLOAD_APP: 'Non riesco a scaricare l\'applicazione',
      GPS_INVALID: 'Il mio segnale GPS risulta non valido',
      GPS_PRECISION: 'La posizione GPS del mio localizzatore è errata',
      LEDS_FIXED: 'I due led del mio localizzatore rimangono fissi',
      NO_GEOFENCE_ALERTS: 'Ricevo false notifiche di entrata e di uscita dalla zona',
      NO_NOTIFICATIONS: 'Non ricevo le notifiche',
      OTHER: 'Altro',
      SIGN_IN: 'Non riesco a connettermi alla mia area personale',
      SUBSCRIPTION: 'Ho un problema con il mio abbonamento',
      TRACKERS_PARAMS: 'Non riesco a impostare il mio localizzatore',
      TRACKER_NOT_CONNECTED: 'Il mio localizzatore risulta non connesso'
    },
    SUBMITTED_TICKET: 'Grazie, abbiamo ricevuto la tua richiesta.\nTi abbiamo inviato un\'e-mail di conferma (ricordati di verificare la posta indesiderata).',
    SUB_TEXT: 'Se queste spiegazioni non sono sufficienti, puoi anche contattare un operatore del nostro servizio clienti, che ti risponderà entro 24 ore lavorative.',
    TITLE: 'Hai bisogno di aiuto?',
    URGENT_NUMBER: 'Se la tua richiesta è urgente puoi contattare il nostro servizio clienti al numero \n+33 187 660 083 dalle 10:00 alle 12:00 e dalle 14:00 alle 17:00 dal lunedì al venerdì.'
  },
  trackerLeftPanel: {
    CALL: 'Chiama',
    CTR_ONLY_SECONDS: 'Ti restano {{SECONDS}} secondo/i di chiamata telefonica per il mese in corso.',
    CTR_WITH_MINUTES: 'Ti restano {{MINUTES}} minuto/i e {{SECONDS}} secondo/i di chiamata telefonica per il mese in corso.',
    FLASH: 'Torcia',
    GOOD_GPS_ACCURACY: 'Buona precisione GPS',
    LAST_POSITION: 'Ultima posizione conosciuta:',
    MEDIUM_GPS_ACCURACY: 'Precisione GPS media',
    OFFLINE: 'Localizzatore non connesso',
    POOR_GPS_ACCURACY: 'Precisione GPS scarsa',
    RING: 'Suoneria',
    SMS_AVAILABLE: 'SMS disponibili : {{SMS_count}}',
    VIBRATE: 'Vibrazione'
  },
  trackerSettings: {
    BUTTONS: {
      LABELS: {
        BUTTON: 'Pulsante'
      },
      PLACEHOLDER_BUTTON: 'Inserisci il messaggio da inviare con il pulsante {{button_number}}',
      TEXT: 'Scrivi un testo da assegnare a ogni pulsante del tuo localizzatore. Riceverai un messaggio di notifica con questo messaggio quando il bottone corrispondente viene premuto.'
    },
    CONTACTS: {
      ADD_EMAIL_BUTTON: 'Aggiungi un indirizzo e-mail',
      ADD_PHONE_BUTTON: 'Aggiungi un numero di cellulare',
      EMAILS_LABEL: 'Indirizzo e-mail per le notifiche tramite posta elettronica',
      MAIL: {
        PLACEHOLDER: 'votre@email.com'
      },
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Si è verificato un problema, ti preghiamo di riprovare.',
        UPDATE_SUCCESS: 'Contatti aggiornati correttamente'
      },
      NUMBERS_LABEL: 'Numero di telefono per le notifiche tramite SMS',
      PHONE: {
        PLACEHOLDER: '+33600000000'
      }
    },
    DISPLAY: {
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Si è verificato un problema',
        UPDATE_SUCCESS: 'Impostazioni aggiornate correttamente'
      },
      MODAL: {
        HEADLINE: 'Seleziona l\'icona',
        TEXT: 'Puoi scegliere l\'icona che preferisci nell\'elenco riportato di seguito. Rappresenterà il tuo localizzatore sulla mappa.'
      },
      TRACKER_ICON: {
        EDIT_TEXT: 'Modifica l\'icona',
        LABEL: 'Icona del localizzatore'
      },
      TRACKER_NAME: {
        LABEL: 'Nome del localizzatore',
        PLACEHOLDER: 'Nome che sarà visualizzato sulla mappa'
      },
      TRACKER_TYPE: {
        CHANGE: 'Cambiare il tipo',
        MODIFIED_SUCCESS: 'Tipo di localizzatore modificato con successo'
      }
    },
    GENERAL_NAME_OF_THE_TRACKER: 'Nome del localizzatore',
    GENERAL_TITLE: 'Generale',
    GPS_FREQUENCY: {
      '10MIN': '10min',
      '10S': '10s',
      '1MIN': '1min',
      '2MIN': '2min',
      '30S': '30s',
      '3MIN': '3min',
      '5MIN': '5min',
      BATTERY_USAGE: 'Autonomia media della batteria:',
      BATTERY_USAGE_LEVELS: {
        HIGH: 'Elevata',
        LOW: 'Breve',
        MEDIUM: 'Media'
      },
      GEOFENCE_NOTIFICATIONS: 'Tempo medio di reazione per gli avvisi recinto virtuale:',
      HINT: 'Una frequenza più ravvicinata riduce l\'autonomia della batteria, ma migliora il tempo di reazione per ingresso e uscita dai zona di sicurezza. Al contrario, una frequenza più distanziata migliora l\'autonomia della batteria, ma riduce il tempo di reazione per ingresso e uscita dai recinti virtuali.',
      OFF: 'OFF',
      TEXT: 'Scegli l\'intervallo di tempo tra ogni posizione GPS'
    },
    NOTIFICATION_SETTINGS: {
      APP: 'Applicazione',
      BATTERY: {
        HINT: 'Invia una notifica a tutti i contatti quando la batteria del localizzatore raggiunge un livello di carica bassa.',
        TITLE: 'Batteria'
      },
      BUTTONS: {
        HINT: 'Invia una notifica a tutti i contatti quando viene premuto uno dei pulsanti laterali. Il messaggio configurato per questo pulsante sarà incluso nella notifica',
        TITLE: 'Pulsanti laterali'
      },
      GEOFENCES: {
        HINT: 'Invia una notifica a tutti i contatti se il localizzatore entra o esce da una zona definita nelle impostazioni.',
        TITLE: 'Zone sicure'
      },
      MAIL: 'E-mail',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Si è verificato un problema, ti preghiamo di riprovare',
        UPDATE_SUCCESS: 'Le impostazioni di notifica sono state aggiornate correttamente.'
      },
      POWERSAVINGAREA: {
        HINT: 'Invia una notifica a tutti i contatti quando il localizzatore entra o esce da una zona impostata.',
        TITLE: 'Zone di risparmio energetico:'
      },
      SMS: 'SMS',
      SOS: {
        HINT: 'Invia una notifica a tutti i contatti premendo il pulsante SOS.',
        TITLE: 'Chiamata SOS'
      },
      WARNING: {
        SMS: {
          LINK: 'Clicca qui per attivare.',
          TEXT: 'Attenzione, se desideri ricevere gli avvisi tramite SMS devi attivare l\'opzione corrispondente.'
        }
      }
    },
    REDIRECTION_MESSAGE: 'Puoi modificare queste impostazioni in qualsiasi momento nell’app Weenect.',
    SECTION_TITLES: {
      BUTTONS: 'Pulsanti',
      CONTACTS: 'Contatti per le notifiche',
      DISPLAY: 'Generale',
      GPS_FREQUENCY: 'Intervallo di tempo tra posizioni GPS',
      NOTIFICATION_SETTINGS: 'Tipi di notifica per ogni avviso',
      SOS: 'Numero SOS',
      TRAINING: 'Funzione telefono'
    },
    TRAINING_SOS: {
      DIRECT_CALL: 'Chiamare direttamente questo numero in caso di allerta SOS.',
      INPUT_PLACEHOLDER: '+33600000000',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Si è verificato un problema, ti preghiamo di riprovare',
        UPDATE_SUCCESS: 'Numero cellulare aggiornato correttamente'
      },
      SOS_TEXT: 'Numero di cellulare che riceverà le chiamate in caso di avviso SOS',
      TRAINING_TEXT: 'Immetti il numero di cellulare predefinito che il localizzatore chiamerà in caso di utilizzo della funzione telefono con l\'applicazione. Questo numero può essere modificato a ogni richiesta di chiamata tramite l\'applicazione.'
    }
  },
  trackers: {
    ADD_TRACKER_BUTTON: {
      LABEL: 'Aggiungi localizzatore'
    },
    EXPIRATION: {
      EXPIRED: 'L\'abbonamento di {{tracker}} è scaduto',
      WILL_EXPIRE: 'L\'abbonamento di {{tracker}} scadrà tra {{days}} giorni'
    },
    LINKS: {
      ACTIVITY: 'Monitoraggio dell\'attività',
      GEOFENCES: 'Zone di sicurezza',
      HISTORY: 'Cronologia',
      SETTINGS: 'Impostazioni',
      SUBSCRIPTION: 'Abbonamento'
    }
  },
  trackersPositionRefresh: {
    MESSAGES: {
      NOT_REFRESHED: 'Il localizzatore non è riuscito ad ottenere nuove posizioni GPS',
      REFRESHING: 'Richiesta di aggiornamento in corso, attendere prego...',
      SUCCESS: 'Posizione GPS dei localizzatori aggiornata correttamente.'
    }
  },
  trackerstatus: {
    AIRPLANE: 'Localizzatore in modalità aereo',
    BATTERY_OFF: 'Localizzatore spento per mancanza di batteria',
    GSM_BAD: 'Debole',
    GSM_GOOD: 'Buono',
    GSM_MEDIUM: 'Medio',
    IN_AIRPLANE_MODE: 'In modalità aereo',
    IN_POWER_SAVING_AREA: 'In zona di risparmio energetico',
    LAST_COMMUNICATION_AGO: 'Ultima comunicazione %s fa',
    LAST_COMMUNICATION_ON: 'Ultima posizione  %s',
    LAST_POSITION_AGO: 'Ultima posizione %s fa',
    LAST_POSITION_ON: 'Ultima posizione  %s',
    NO_BATTERY: 'Batteria scarica',
    NO_POSITION: 'Nessuna posizione conosciuta',
    NO_SUBSCRIPTION: 'Nessun abbonamento attivo',
    OFFLINE: 'Localizzatore disconnesso',
    OFFLINE_GSM: 'Fuori rete GSM',
    OFFLINE_MANUAL: 'Spento manuale',
    ONLINE: 'Localizzatore connesso',
    POSITION_BAD: 'Debole',
    POSITION_GOOD: 'Buono',
    POSITION_MEDIUM: 'Mediocre',
    POSITION_WIFI_NO_NAME: 'Non identificato',
    TURN_OFF: 'Localizzatore spento manualmente'
  },
  transferPage: {
    ADD_TRACKER: 'Voglio aggiungere un nuovo localizzatore al mio account',
    BACK_TO_TRACKERS: 'Torna alla mappa',
    FIRST_TITLE: 'Cosa vuoi fare esattamente?',
    FROM_HEADLINE: 'Localizzatore da sostituire:',
    HEADLINE: 'Sostituzione di un localizzatore',
    IMEI_LABEL: 'Numero IMEI',
    INFO: 'L\'abbonamento attuale e le impostazioni saranno trasferiti sul nuovo localizzatore dopo la sostituzione. La cronologia delle posizioni GPS del precedente localizzatore andrà persa.',
    MESSAGES: {
      ERROR_UNKNOWN: 'Si è verificato un problema, ti preghiamo di riprovare',
      SUCCESS: 'Nuovo localizzatore registrato correttamente',
      WRONG_TYPE: 'Il localizzatore con questo numero IMEI non corrisponde al tipo del tuo vecchio localizzatore. Contatta il nostro servizio clienti.'
    },
    NAME_LABEL: 'Nome del localizzatore',
    PURCHASE: 'Non hai ancora un localizzatore Weenect? <1>Puoi acquistarne uno qui</1>',
    REPLACE_BUTTON: {
      LABEL: 'Sostituisci'
    },
    REPLACE_TRACKER: 'Voglio sostituire un localizzatore esistente',
    TO_HEADLINE: 'Nuovo localizzatore:'
  },
  translation: {
    account_payment_sepa_mandate: 'mandato SEPA'
  },
  webappDisconnection: {
    BUG: 'Non connesso',
    MANUAL: 'Hai spento Il tuo localizzatore. Premi il pulsante ON per riaccenderlo.',
    NO_BATTERY: 'Il tuo localizzatore si è spento perché la batteria era scarica.',
    NO_SUB: 'Non disponi di un abbonamento per questo localizzatore. Ti invitiamo a procurartene uno visitando il sito'
  },
  wifiZones: {
    AIRPLANE_TEXT: 'Avviso: in modalità aereo, finché il localizzatore si trova nella zona di risparmio energetico, non puoi più far squillare, vibrare o aggiornare manualmente la posizione.',
    DEEP_SLEEP_TITLE: 'Modalità aereo',
    DISPLAY_BUTTON: 'Visualizza la zona sulla mappa',
    DISPLAY_TITLE: 'Notifiche',
    IN_AIRPLANE: '- in modalità aereo',
    IN_OUT_TEXT: 'Entrate e uscite dal recinto:',
    LAST_POS_IN_WIFI: 'Nel Zone di Risparmio energetico dal {{date}}',
    MAIL_NOTIF: 'Notifications Mail',
    NOTIF_TEXT: 'Ricevi una notifica per ogni ingresso o uscita da una zona.',
    POPIN: {
      AIRPLANE: {
        BUTTON_VALIDATE: 'Esci dalla modalità aereo',
        CONTENT: '<p>Non è più possibile comunicare con il localizzatore quando si trova nella zona di risparmio energetico. Se si desidera recuperare la piena funzionalità, <strong>disattivare la modalità aereo e portare il localizzatore fuori dalla zona</strong>.<b><br /></b></p>',
        TITLE: 'Il tuo localizzatore è in modalità aereo nella zona di risparmio energetico {{wifiName}}.'
      },
      BUTTON_CLOSE: 'Più tardi',
      BUTTON_VALIDATE: 'Disattivare questa zona',
      CONTENT: 'In questa zona l\'invio automatico delle posizioni GPS del tuo localizzatore è disattivato poiché sappiamo che si trova nella zona. Puoi disattivare questa zona in qualsiasi momento dalla scheda "Localizzatore".',
      TITLE: 'Il tuo localizzatore si trova nella zona di risparmio energetico {{wifiName}}.'
    },
    PUSH_NOTIF: 'Notifications push',
    SMS_NOTIF: 'Notifications SMS',
    TITLE: 'Zone di Risparmio energetico',
    ZONE_ACTIVATION: 'Attiva la zona'
  }
}
